/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
export interface AcceptIntroductionRequest {
  introductionId: number;
  status: 'mutual-intro-one';
}

export type AcceptedApplicantDataApplicationDate = string | null;

export type AcceptedApplicantDataIsOffTrack = boolean | null;

export type AcceptedApplicantDataMatchData = ApplicantMatchData | null;

export type AcceptedApplicantDataMatchStatus = CorporateAdminMatchStatus | null;

export type AcceptedApplicantDataRecentUpdate = RecentUpdateData | null;

export interface AcceptedApplicantData {
  applicationDate: AcceptedApplicantDataApplicationDate;
  email: string;
  id: number;
  isOffTrack: AcceptedApplicantDataIsOffTrack;
  matchData: AcceptedApplicantDataMatchData;
  matchStatus: AcceptedApplicantDataMatchStatus;
  name: string;
  recentUpdate: AcceptedApplicantDataRecentUpdate;
}

export interface AcceptedIntroPayload {
  email_type?: 'INTRO_ACCEPTED';
  introduction_id: number;
}

export type AccountTypeEnum = (typeof AccountTypeEnum)[keyof typeof AccountTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountTypeEnum = {
  experteer: 'experteer',
  organization: 'organization',
  administrator: 'administrator',
  partner: 'partner',
  corporate: 'corporate',
} as const;

export type ActionUpdateOutcomeEnum =
  (typeof ActionUpdateOutcomeEnum)[keyof typeof ActionUpdateOutcomeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionUpdateOutcomeEnum = {
  complete: 'complete',
  unresponsive: 'unresponsive',
  in_progress: 'in_progress',
  different_update: 'different_update',
} as const;

export type ActionUpdateRequestNotes = string | null;

export interface ActionUpdateRequest {
  isTeam: boolean;
  notes: ActionUpdateRequestNotes;
  outcome: ActionUpdateOutcomeEnum;
  projectId: number;
}

export type AdminCohortApplicationEndDate = string | null;

export type AdminCohortApplicationStartDate = string | null;

export type AdminCohortDuration = string | null;

export type AdminCohortEngagementEndDate = string | null;

export type AdminCohortEngagementStartDate = string | null;

export type AdminCohortKickoffDate = string | null;

export type AdminCohortTemplate = CohortTemplate | null;

export type AdminCohortTimeCommitment = string | null;

export type AdminCohortWrapupDate = string | null;

export interface AdminCohort {
  applicationEndDate: AdminCohortApplicationEndDate;
  applicationStartDate: AdminCohortApplicationStartDate;
  clientId: number;
  clientName: string;
  createdAt: string;
  duration: AdminCohortDuration;
  engagementEndDate: AdminCohortEngagementEndDate;
  engagementStartDate: AdminCohortEngagementStartDate;
  id: number;
  kickoffDate: AdminCohortKickoffDate;
  name: string;
  template: AdminCohortTemplate;
  timeCommitment: AdminCohortTimeCommitment;
  updatedAt: string;
  wrapupDate: AdminCohortWrapupDate;
}

export interface AdminCohortsResponse {
  cohorts: AdminCohort[];
  filteredCount: number;
}

export type AdminEmailHtml = string | null;

export type AdminEmailIntroductionId = number | null;

export type AdminEmailMatchOrganizationName = string | null;

export type AdminEmailSubject = string | null;

export type AdminEmailTeamAssignmentDiscoveryId = number | null;

export type AdminEmailTemplateHtml = string | null;

export interface AdminEmail {
  emailStatus: AdminEmailStatus;
  emailType: string;
  html: AdminEmailHtml;
  introductionId: AdminEmailIntroductionId;
  matchOrganizationName: AdminEmailMatchOrganizationName;
  scheduledFor: string;
  subject: AdminEmailSubject;
  teamAssignmentDiscoveryId: AdminEmailTeamAssignmentDiscoveryId;
  templateHtml: AdminEmailTemplateHtml;
  toUserFirstName: string;
  toUserId: number;
  toUserLastName: string;
}

export type AdminEmailStatus = (typeof AdminEmailStatus)[keyof typeof AdminEmailStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminEmailStatus = {
  scheduled: 'scheduled',
  sent: 'sent',
  failed: 'failed',
} as const;

export interface AdminEmailsResponse {
  emails: AdminEmail[];
}

export type AdminIntroExportCohort = string | null;

export type AdminIntroExportProjectId = number | null;

export type AdminIntroExportProjectName = string | null;

export interface AdminIntroExport {
  cohort: AdminIntroExportCohort;
  createdAt: string;
  introductionId: number;
  introductionInitiationType: string;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  organizationId: number;
  organizationName: string;
  professionalEmail: string;
  professionalId: number;
  professionalName: string;
  projectId: AdminIntroExportProjectId;
  projectName: AdminIntroExportProjectName;
  representativeEmail: string;
  representativeId: number;
  representativeName: string;
}

/**
 * Response model for admin introductions export
 */
export interface AdminIntroExportResponse {
  introductions: AdminIntroExport[];
}

/**
 * Response model for admin introductions
 */
export interface AdminIntroResponse {
  introductions: AdminIntroduction[];
  totalCount: number;
}

export type AdminIntroductionCohort = string | null;

export type AdminIntroductionProjectId = number | null;

export type AdminIntroductionProjectName = string | null;

export interface AdminIntroduction {
  cohort: AdminIntroductionCohort;
  createdAt: string;
  introductionId: number;
  introductionInitiationType: string;
  message: string;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  organizationId: number;
  organizationName: string;
  professionalId: number;
  professionalName: string;
  projectId: AdminIntroductionProjectId;
  projectName: AdminIntroductionProjectName;
  representativeId: number;
  representativeName: string;
}

export interface AdminMeeting {
  attended: number;
  duration: number;
  id: number;
  joinUrl: string;
  registered: number;
  registrationRequired: boolean;
  startTime: string;
  title: string;
  zoomHost: string;
  zoomId: string;
}

export interface AdminMeetingResponse {
  filteredCount: number;
  meetings: AdminMeeting[];
}

export interface AdminMicrostoriesResponse {
  filteredCount: number;
  microstories: AdminMicrostory[];
}

export type AdminMicrostoryCorporateClientId = number | null;

export type AdminMicrostoryCorporateClientName = string | null;

export type AdminMicrostoryImpactPartnerId = number | null;

export type AdminMicrostoryImpactPartnerName = string | null;

export type AdminMicrostoryOrganizationId = number | null;

export type AdminMicrostoryOrganizationName = string | null;

export type AdminMicrostoryUrlOrFileRef = string | null;

export type AdminMicrostoryUserId = number | null;

export type AdminMicrostoryUserType = SimplifiedUserRole | null;

export interface AdminMicrostory {
  consentToShare: boolean;
  contactName: string;
  corporateClientId: AdminMicrostoryCorporateClientId;
  corporateClientName: AdminMicrostoryCorporateClientName;
  createdAt: string;
  id: number;
  impactPartnerId: AdminMicrostoryImpactPartnerId;
  impactPartnerName: AdminMicrostoryImpactPartnerName;
  microstory: string;
  organizationId: AdminMicrostoryOrganizationId;
  organizationName: AdminMicrostoryOrganizationName;
  source: MicrostorySource;
  storyDate: string;
  updatedAt: string;
  urlOrFileRef: AdminMicrostoryUrlOrFileRef;
  userId: AdminMicrostoryUserId;
  userType: AdminMicrostoryUserType;
}

export interface AdminOrgMatchDataResponse {
  matchRecords: AdminOrgMatchRecord[];
  totalCount: number;
}

export type AdminOrgMatchRecordProjectId = number | null;

export type AdminOrgMatchRecordProjectName = string | null;

export interface AdminOrgMatchRecord {
  introductionCreatedAt: string;
  introductionId: number;
  introductionInitiationType: string;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  professionalId: number;
  professionalName: string;
  projectId: AdminOrgMatchRecordProjectId;
  projectName: AdminOrgMatchRecordProjectName;
  representativeId: number;
  representativeName: string;
}

export interface AdminOrgProject {
  id: number;
  name: string;
  publishingStage: ProjectPublishingStage;
}

export interface AdminOrgTeamMatchDataResponse {
  matchRecords: AdminOrgTeamMatchRecord[];
  totalCount: number;
}

export type AdminOrgTeamMatchRecordProjectId = number | null;

export type AdminOrgTeamMatchRecordProjectName = string | null;

export interface AdminOrgTeamMatchRecord {
  cohortId: number;
  discoveryId: number;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  projectId: AdminOrgTeamMatchRecordProjectId;
  projectName: AdminOrgTeamMatchRecordProjectName;
  representativeId: number;
  representativeName: string;
  teamId: number;
}

export type AdminOrganizationApplicationId = number | null;

export type AdminOrganizationApplicationStatus = OrganizationApplicationStatusEnum | null;

export type AdminOrganizationApplicationUpdated = string | null;

export type AdminOrganizationCauses = string[] | null;

export type AdminOrganizationIndustries = string[] | null;

export type AdminOrganizationMatchingNetworks = string[] | null;

export type AdminOrganizationProjects = AdminOrgProject[] | null;

export interface AdminOrganization {
  applicationId: AdminOrganizationApplicationId;
  applicationStatus: AdminOrganizationApplicationStatus;
  applicationUpdated: AdminOrganizationApplicationUpdated;
  causes: AdminOrganizationCauses;
  createdAt: string;
  id: number;
  industries: AdminOrganizationIndustries;
  matchingNetworks: AdminOrganizationMatchingNetworks;
  name: string;
  projects: AdminOrganizationProjects;
}

export interface AdminOrganizationsResponse {
  filteredCount: number;
  organizations: AdminOrganization[];
}

export type AdminPartnerLogo = string | null;

export interface AdminPartner {
  active: boolean;
  createdAt: string;
  id: number;
  logo: AdminPartnerLogo;
  name: string;
  updatedAt: string;
}

export interface AdminPartnersResponse {
  filteredCount: number;
  partners: AdminPartner[];
}

export type AdminProExportApplicationDate = string | null;

export type AdminProExportApplicationId = number | null;

export type AdminProExportApplicationStatus = ProfessionalApplicationStatusEnum | null;

export type AdminProExportBusinessUnit = string | null;

export type AdminProExportCauses = string[] | null;

export type AdminProExportCity = string | null;

export type AdminProExportCommitted = boolean | null;

export type AdminProExportCountry = string | null;

export type AdminProExportDepartment = string | null;

export type AdminProExportExperience = number | null;

export type AdminProExportHeadline = string | null;

export type AdminProExportIdealProjects = string | null;

export type AdminProExportIndustries = string[] | null;

export type AdminProExportJobTitle = string | null;

export type AdminProExportLanguages = string[] | null;

export type AdminProExportLinkedinUrl = string | null;

export type AdminProExportManagerConsent = boolean | null;

export type AdminProExportMobile = string | null;

export type AdminProExportMotivationText = string | null;

export type AdminProExportPreviousExperience = string | null;

export type AdminProExportResume = string | null;

export type AdminProExportSkillExplanation = string | null;

export type AdminProExportSource = string | null;

export type AdminProExportTheatre = string | null;

export type AdminProExportTimezone = string | null;

export interface AdminProExport {
  applicationDate: AdminProExportApplicationDate;
  applicationId: AdminProExportApplicationId;
  applicationStatus: AdminProExportApplicationStatus;
  applyCompleted: boolean;
  businessUnit: AdminProExportBusinessUnit;
  causes: AdminProExportCauses;
  city: AdminProExportCity;
  clientName: string;
  cohortName: string;
  committed: AdminProExportCommitted;
  country: AdminProExportCountry;
  createdAt: string;
  department: AdminProExportDepartment;
  email: string;
  emailVerified: boolean;
  experience: AdminProExportExperience;
  headline: AdminProExportHeadline;
  id: number;
  idealProjects: AdminProExportIdealProjects;
  industries: AdminProExportIndustries;
  isDisabled: boolean;
  isInactive: boolean;
  jobTitle: AdminProExportJobTitle;
  languages: AdminProExportLanguages;
  linkedinUrl: AdminProExportLinkedinUrl;
  managerConsent: AdminProExportManagerConsent;
  mobile: AdminProExportMobile;
  motivationText: AdminProExportMotivationText;
  name: string;
  previousExperience: AdminProExportPreviousExperience;
  resume: AdminProExportResume;
  skillExplanation: AdminProExportSkillExplanation;
  skills: string[];
  source: AdminProExportSource;
  theatre: AdminProExportTheatre;
  timezone: AdminProExportTimezone;
}

export interface AdminProExportResponse {
  professionals: AdminProExport[];
}

export interface AdminProMatchDataResponse {
  matchRecords: AdminProMatchRecord[];
  totalCount: number;
}

export type AdminProMatchRecordProjectId = number | null;

export type AdminProMatchRecordProjectName = string | null;

export interface AdminProMatchRecord {
  introductionCreatedAt: string;
  introductionId: number;
  introductionInitiationType: string;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  organizationId: number;
  organizationName: string;
  projectId: AdminProMatchRecordProjectId;
  projectName: AdminProMatchRecordProjectName;
}

export interface AdminProTeamMatchDataResponse {
  teamMatchRecords: AdminProTeamMatchRecord[];
  totalCount: number;
}

export type AdminProTeamMatchRecordProjectId = number | null;

export type AdminProTeamMatchRecordProjectName = string | null;

export interface AdminProTeamMatchRecord {
  cohortId: number;
  discoveryId: number;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  organizationId: number;
  organizationName: string;
  projectId: AdminProTeamMatchRecordProjectId;
  projectName: AdminProTeamMatchRecordProjectName;
  teamId: number;
}

export type AdminProfessionalApplicationDate = string | null;

export type AdminProfessionalApplicationId = number | null;

export type AdminProfessionalApplicationStatus = ProfessionalApplicationStatusEnum | null;

export interface AdminProfessional {
  applicationDate: AdminProfessionalApplicationDate;
  applicationId: AdminProfessionalApplicationId;
  applicationStatus: AdminProfessionalApplicationStatus;
  applyCompleted: boolean;
  clientName: string;
  cohortName: string;
  createdAt: string;
  email: string;
  emailVerified: boolean;
  id: number;
  isDisabled: boolean;
  isInactive: boolean;
  name: string;
  skills: string[];
}

export interface AdminProfessionalResponse {
  filteredCount: number;
  professionals: AdminProfessional[];
}

export type AdminProjectCohorts = string[] | null;

export type AdminProjectEndDate = string | null;

export type AdminProjectOrganizationId = number | null;

export type AdminProjectOrganizationName = string | null;

export type AdminProjectRepresentativeId = number | null;

export type AdminProjectRepresentativeName = string | null;

export type AdminProjectStartDate = string | null;

export interface AdminProject {
  cohorts: AdminProjectCohorts;
  createdAt: string;
  endDate: AdminProjectEndDate;
  id: number;
  name: string;
  openToTeam: boolean;
  organizationId: AdminProjectOrganizationId;
  organizationName: AdminProjectOrganizationName;
  publishingStage: ProjectPublishingStage;
  publishingStageUpdatedDate: string;
  representativeId: AdminProjectRepresentativeId;
  representativeName: AdminProjectRepresentativeName;
  skills: string[];
  stage: ProjectStage;
  startDate: AdminProjectStartDate;
}

export interface AdminProjectMatchDataResponse {
  matchRecords: AdminProjectMatchRecord[];
  totalCount: number;
}

export interface AdminProjectMatchRecord {
  introductionCreatedAt: string;
  introductionId: number;
  introductionInitiationType: string;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  professionalId: number;
  professionalName: string;
  representativeId: number;
  representativeName: string;
}

export type AdminProjectPlanAvailabilityNotes = string | null;

export type AdminProjectPlanCommunicationNotes = string | null;

export type AdminProjectPlanDeliverables = PlanDeliverable[] | null;

export type AdminProjectPlanNextSteps = string | null;

export type AdminProjectPlanOrganizationBrief = PlanOrgBrief | null;

export type AdminProjectPlanProfessionalBrief = PlanProBrief | null;

export type AdminProjectPlanSkills = PlanSkillAlignment[] | null;

export type AdminProjectPlanTasks = PlanTasks[] | null;

export type AdminProjectPlanUpdatedAt = string | null;

export interface AdminProjectPlan {
  availabilityNotes: AdminProjectPlanAvailabilityNotes;
  communicationNotes: AdminProjectPlanCommunicationNotes;
  deliverables: AdminProjectPlanDeliverables;
  nextSteps: AdminProjectPlanNextSteps;
  organizationBrief: AdminProjectPlanOrganizationBrief;
  professionalBrief: AdminProjectPlanProfessionalBrief;
  skills: AdminProjectPlanSkills;
  tasks: AdminProjectPlanTasks;
  updatedAt: AdminProjectPlanUpdatedAt;
}

export interface AdminProjectResponse {
  filteredCount: number;
  projects: AdminProject[];
}

export interface AdminProjectTeamMatchDataResponse {
  matchRecords: AdminProjectTeamMatchRecord[];
  totalCount: number;
}

export interface AdminProjectTeamMatchRecord {
  cohortId: number;
  discoveryId: number;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  representativeId: number;
  representativeName: string;
  teamId: number;
}

export interface AdminRegistrationDetail {
  attended: boolean;
  createdAt: string;
  email: string;
  id: number;
  name: string;
}

export type AdminRepresentativeOrganizationApplicationStatus =
  OrganizationApplicationStatusEnum | null;

export type AdminRepresentativeOrganizationId = number | null;

export type AdminRepresentativeOrganizationName = string | null;

export interface AdminRepresentative {
  createdAt: string;
  email: string;
  emailVerified: boolean;
  id: number;
  name: string;
  organizationApplicationStatus: AdminRepresentativeOrganizationApplicationStatus;
  organizationId: AdminRepresentativeOrganizationId;
  organizationName: AdminRepresentativeOrganizationName;
  updatedAt: string;
}

export interface AdminRepresentativesResponse {
  filteredCount: number;
  representatives: AdminRepresentative[];
}

export type AdminTeamAssignedProjectProperty = AdminTeamAssignedProject | null;

export interface AdminTeam {
  assignedProject: AdminTeamAssignedProjectProperty;
  categories: SkillCategoriesEnum[];
  cohortName: string;
  id: number;
  members: AdminTeamMember[];
  status: UserTeamAssignmentStatusEnum;
}

export interface AdminTeamAssignedProject {
  id: number;
  name: string;
  status: DiscoveryDecision;
  statusDate: string;
}

export type AdminTeamDetailedAssignedProject = AdminTeamAssignedProject | null;

export interface AdminTeamDetailed {
  assignedProject: AdminTeamDetailedAssignedProject;
  categories: SkillCategoriesEnum[];
  cohortName: string;
  id: number;
  members: AdminTeamMemberDetailed[];
  skillsProficiencies: TeamSkillProficiency[];
  status: UserTeamAssignmentStatusEnum;
}

export interface AdminTeamMatchExport {
  cohort: string;
  corporateClient: string;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  organization: string;
  project: string;
  representativeEmail: string;
  representativeName: string;
  teamDiscoveryId: number;
  teamId: number;
  teamMemberEmails: string;
  teamMemberNames: string;
}

export interface AdminTeamMatchExportResponse {
  matches: AdminTeamMatchExport[];
}

export interface AdminTeamMatchResponse {
  matches: TeamMatchDetails[];
  totalCount: number;
}

export interface AdminTeamMember {
  id: number;
  name: string;
  skills: AdminTeamMemberSkill[];
  timezone: string;
}

export type AdminTeamMemberDetailedJobTitle = string | null;

export type AdminTeamMemberDetailedLinkedinUrl = string | null;

export type AdminTeamMemberDetailedResume = string | null;

export type AdminTeamMemberDetailedSkillsExplanation = string | null;

export interface AdminTeamMemberDetailed {
  city: string;
  country: string;
  id: number;
  jobTitle: AdminTeamMemberDetailedJobTitle;
  linkedinUrl: AdminTeamMemberDetailedLinkedinUrl;
  name: string;
  resume: AdminTeamMemberDetailedResume;
  skills: AdminTeamMemberSkill[];
  skillsExplanation: AdminTeamMemberDetailedSkillsExplanation;
  timezone: string;
}

export type AdminTeamMemberSkillCategory = SkillCategoriesEnum | null;

export type AdminTeamMemberSkillProficiency = string | null;

export type AdminTeamMemberSkillProficiencyId = number | null;

export interface AdminTeamMemberSkill {
  category: AdminTeamMemberSkillCategory;
  proficiency: AdminTeamMemberSkillProficiency;
  proficiencyId: AdminTeamMemberSkillProficiencyId;
  skill: string;
}

export interface AdminTeamsResponse {
  teams: AdminTeam[];
  total: number;
}

export type AdminUserApplicationStatus = ProfessionalApplicationStatusEnum | null;

export type AdminUserAvatar = string | null;

export type AdminUserCohort = Cohort | null;

export type AdminUserCorporatePartner = string | null;

export type AdminUserCorporatePartnerLogo = string | null;

export type AdminUserLocation = Location | null;

export interface AdminUser {
  accountType: 'administrator';
  applicationRoute: string;
  applicationStatus: AdminUserApplicationStatus;
  avatar: AdminUserAvatar;
  cohort: AdminUserCohort;
  corporatePartner: AdminUserCorporatePartner;
  corporatePartnerLogo: AdminUserCorporatePartnerLogo;
  firstName: string;
  lastName: string;
  location: AdminUserLocation;
  role: string;
  tocAgreed: boolean;
  userId: number;
  userName: string;
}

export interface AllCohortsResponse {
  cohorts: SrcRoutersAdminCohortsSimpleCohort[];
}

export type AnnouncementTypeEnum = (typeof AnnouncementTypeEnum)[keyof typeof AnnouncementTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnnouncementTypeEnum = {
  professional: 'professional',
  organization: 'organization',
} as const;

export interface ApplicantMatchData {
  projectEndDate: string;
  projectId: number;
  projectName: string;
  projectStartDate: string;
  projectStatus: CorporateAdminMatchStatus;
  projectStatusDate: string;
}

export type AssignProjectRequestOrganizationDecision =
  (typeof AssignProjectRequestOrganizationDecision)[keyof typeof AssignProjectRequestOrganizationDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignProjectRequestOrganizationDecision = {
  pending: 'pending',
  accepted: 'accepted',
  declined: 'declined',
} as const;

export type AssignProjectRequestScheduledSendDate = string | null;

export interface AssignProjectRequest {
  organizationDecision: AssignProjectRequestOrganizationDecision;
  projectId: number;
  scheduledSendDate: AssignProjectRequestScheduledSendDate;
  sendEmail: boolean;
  teamId: number;
}

/**
 * The reasons why a user declined an assignment. Note that this is used for both pros and orgs, but
each type of user is only offered a subset of the total set of options.
 */
export type AssignmentDeclinedReason =
  (typeof AssignmentDeclinedReason)[keyof typeof AssignmentDeclinedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignmentDeclinedReason = {
  choosing_different_pro: 'choosing_different_pro',
  choosing_different_org: 'choosing_different_org',
  user_disabled: 'user_disabled',
  wrong_skills: 'wrong_skills',
  project_no_longer_fits: 'project_no_longer_fits',
  timezone_or_availability: 'timezone_or_availability',
  system_other_choice: 'system_other_choice',
  other: 'other',
} as const;

export type BoardAreaEnum = (typeof BoardAreaEnum)[keyof typeof BoardAreaEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BoardAreaEnum = {
  'strategy-operations': 'strategy-operations',
  'customer-value-group': 'customer-value-group',
  'finance-administration': 'finance-administration',
  'ceo-office': 'ceo-office',
  'people-culture': 'people-culture',
  'product-engineering': 'product-engineering',
} as const;

export interface BodyBatchImportIntroductions {
  file: string;
}

export interface BodyBatchImportProjects {
  file: string;
}

export interface BodyUploadLogo {
  file: string;
}

export interface BodyUploadProfilePicture {
  file: string;
}

export interface BodyUploadResume {
  file: string;
}

export type BusinessChallengeChallenge = string | null;

export type BusinessChallengeChallengeContext = string | null;

export interface BusinessChallenge {
  challenge: BusinessChallengeChallenge;
  challengeContext: BusinessChallengeChallengeContext;
  challengeNumber: number;
}

export interface BusinessChallengeSuggestionRequest {
  challengeId: number;
  challengeIdx: number;
  organizationId: number;
}

export type BusinessChallengesEnum =
  (typeof BusinessChallengesEnum)[keyof typeof BusinessChallengesEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessChallengesEnum = {
  'product-market-fit': 'product-market-fit',
  'branding-and-positioning': 'branding-and-positioning',
  marketing: 'marketing',
  sales: 'sales',
  'customer-success': 'customer-success',
  'reporting-and-communicating-impact': 'reporting-and-communicating-impact',
  'fundraising-preparation': 'fundraising-preparation',
  'human-resources': 'human-resources',
  'business-operations': 'business-operations',
  'accounting-and-finance': 'accounting-and-finance',
  legal: 'legal',
} as const;

export interface BusinessChallengesRequest {
  firstBusinessChallenge: string;
  firstBusinessChallengeDescription: string;
  secondBusinessChallenge: string;
  secondBusinessChallengeDescription: string;
  thirdBusinessChallenge: string;
  thirdBusinessChallengeDescription: string;
}

export type BusinessModel = (typeof BusinessModel)[keyof typeof BusinessModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessModel = {
  B2B: 'B2B',
  B2C: 'B2C',
  'B2B-and-B2C': 'B2B-and-B2C',
  Other: 'Other',
} as const;

export type CanSendIntroCTAStateProjectId = number | null;

export type CanSendIntroCTAStateUncontactedProjects = ProjectAvailableForIntro[] | null;

export interface CanSendIntroCTAState {
  projectId: CanSendIntroCTAStateProjectId;
  state: 'can_send';
  uncontactedProjects: CanSendIntroCTAStateUncontactedProjects;
}

export type CanSendIntroReceivedIntroCTAStateUncontactedProjects =
  ProjectAvailableForIntro[] | null;

export interface CanSendIntroReceivedIntroCTAState {
  date: string;
  details: SentIntroDetails;
  introId: number;
  projectId: number;
  state: 'can_send_intro_received';
  uncontactedProjects: CanSendIntroReceivedIntroCTAStateUncontactedProjects;
}

export type CanSendIntroSentIntroCTAStateUncontactedProjects = ProjectAvailableForIntro[] | null;

export interface CanSendIntroSentIntroCTAState {
  date: string;
  details: SentIntroDetails;
  introId: number;
  projectId: number;
  state: 'can_send_intro_sent';
  uncontactedProjects: CanSendIntroSentIntroCTAStateUncontactedProjects;
}

export type CardStatusEnum = (typeof CardStatusEnum)[keyof typeof CardStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardStatusEnum = {
  intro_pro_sent_pending: 'intro_pro_sent_pending',
  intro_pro_sent_declined: 'intro_pro_sent_declined',
  intro_pro_sent_withdrawn: 'intro_pro_sent_withdrawn',
  intro_pro_sent_expired: 'intro_pro_sent_expired',
  intro_org_sent_pending: 'intro_org_sent_pending',
  intro_org_sent_declined: 'intro_org_sent_declined',
  intro_org_sent_withdrawn: 'intro_org_sent_withdrawn',
  intro_org_sent_expired: 'intro_org_sent_expired',
  intro_system_declined_other_pro: 'intro_system_declined_other_pro',
  intro_system_declined_other_project: 'intro_system_declined_other_project',
  discovery_pending: 'discovery_pending',
  discovery_org_accepted: 'discovery_org_accepted',
  discovery_pro_declined: 'discovery_pro_declined',
  discovery_org_declined: 'discovery_org_declined',
  discovery_system_declined_other_pro: 'discovery_system_declined_other_pro',
  discovery_system_declined_other_project: 'discovery_system_declined_other_project',
  project_prep_pending: 'project_prep_pending',
  project_work_pending: 'project_work_pending',
  project_survey_pending: 'project_survey_pending',
  project_active: 'project_active',
  project_complete: 'project_complete',
  project_assigned_no_updates: 'project_assigned_no_updates',
} as const;

export interface Cause {
  description: string;
  id: number;
  name: string;
  shortDescription: string;
  shortName: string;
}

export type ChallengeUpdateArgsChallengeNumber =
  (typeof ChallengeUpdateArgsChallengeNumber)[keyof typeof ChallengeUpdateArgsChallengeNumber];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChallengeUpdateArgsChallengeNumber = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export interface ChallengeUpdateArgs {
  challenge_context: string;
  challenge_number: ChallengeUpdateArgsChallengeNumber;
  challenge_value: BusinessChallengesEnum;
}

export interface ChangePasswordRequest {
  newPassword: string;
}

export interface ClosedPendingResponse {
  closedDiscoveries: number[];
  closedIntros: number[];
}

export type CohortDuration = string | null;

export type CohortEngagementEndDate = string | null;

export type CohortEngagementStartDate = string | null;

export type CohortTimeCommitment = string | null;

export type CohortUrl = string | null;

export interface Cohort {
  cohortId: number;
  displayName: string;
  duration: CohortDuration;
  engagementEndDate: CohortEngagementEndDate;
  engagementStartDate: CohortEngagementStartDate;
  timeCommitment: CohortTimeCommitment;
  url: CohortUrl;
}

export type CohortBaseDetailDuration = string | null;

export type CohortBaseDetailTimeCommitment = string | null;

export type CohortBaseDetailUrl = string | null;

export interface CohortBaseDetail {
  cohortType: CohortType;
  description: string;
  duration: CohortBaseDetailDuration;
  engagementEndDate: string;
  engagementStartDate: string;
  id: number;
  kickoffDate: string;
  name: string;
  progressDates: CohortProgressDates;
  timeCommitment: CohortBaseDetailTimeCommitment;
  url: CohortBaseDetailUrl;
  wrapupDate: string;
}

export interface CohortClient {
  id: number;
  name: string;
}

export interface CohortClientResponse {
  clients: CohortClient[];
}

export type CohortCreateRequestDescription = string | null;

export type CohortCreateRequestUrl = string | null;

export interface CohortCreateRequest {
  applicationEndDate: string;
  applicationStartDate: string;
  available: boolean;
  clientId: number;
  description: CohortCreateRequestDescription;
  duration: string;
  engagementEndDate: string;
  engagementStartDate: string;
  kickoffDate: string;
  name: string;
  templateId: string;
  timeCommitment: string;
  url: CohortCreateRequestUrl;
  wrapupDate: string;
}

export type CohortDataApplicationEnd = string | null;

export type CohortDataApplicationStart = string | null;

export type CohortDataEngagementEndDate = string | null;

export type CohortDataEngagementStartDate = string | null;

export type CohortDataProgressDates = CohortProgressDates | null;

export type CohortDataType = CohortType | null;

export type CohortDataWrapupDate = string | null;

export interface CohortData {
  applicationEnd: CohortDataApplicationEnd;
  applicationStart: CohortDataApplicationStart;
  engagementEndDate: CohortDataEngagementEndDate;
  engagementStartDate: CohortDataEngagementStartDate;
  id: number;
  name: string;
  progressDates: CohortDataProgressDates;
  type: CohortDataType;
  wrapupDate: CohortDataWrapupDate;
}

export type CohortDetailsApplicationEndDate = string | null;

export type CohortDetailsApplicationStartDate = string | null;

export type CohortDetailsDescription = string | null;

export type CohortDetailsDuration = string | null;

export type CohortDetailsEngagementEndDate = string | null;

export type CohortDetailsEngagementStartDate = string | null;

export type CohortDetailsKickoffDate = string | null;

export type CohortDetailsTemplate = CohortTemplate | null;

export type CohortDetailsTimeCommitment = string | null;

export type CohortDetailsUrl = string | null;

export type CohortDetailsWrapupDate = string | null;

export interface CohortDetails {
  applicationEndDate: CohortDetailsApplicationEndDate;
  applicationStartDate: CohortDetailsApplicationStartDate;
  available: boolean;
  clientId: number;
  clientName: string;
  description: CohortDetailsDescription;
  duration: CohortDetailsDuration;
  engagementEndDate: CohortDetailsEngagementEndDate;
  engagementStartDate: CohortDetailsEngagementStartDate;
  id: number;
  kickoffDate: CohortDetailsKickoffDate;
  name: string;
  template: CohortDetailsTemplate;
  timeCommitment: CohortDetailsTimeCommitment;
  url: CohortDetailsUrl;
  wrapupDate: CohortDetailsWrapupDate;
}

export type CohortNotificationNotifiedAt = string | null;

export interface CohortNotification {
  createdAt: string;
  notifiedAt: CohortNotificationNotifiedAt;
}

/**
 * Represents the derived milestone dates for a cohort based on its kickoff, start, and end dates. These dates are used to determine which milestone stage a user is currently in vs expectation.
 */
export interface CohortProgressDates {
  actionEnd: string;
  actionStart: string;
  matchingEnd: string;
  matchingStart: string;
  planningEnd: string;
  planningStart: string;
  reflect: string;
}

export type CohortResponseDuration = string | null;

export type CohortResponseEngagementEndDate = string | null;

export type CohortResponseEngagementStartDate = string | null;

export type CohortResponseTimeCommitment = string | null;

export type CohortResponseWrapupDate = string | null;

export interface CohortResponse {
  cohortId: number;
  description: string;
  displayName: string;
  duration: CohortResponseDuration;
  engagementEndDate: CohortResponseEngagementEndDate;
  engagementStartDate: CohortResponseEngagementStartDate;
  isClosed: boolean;
  timeCommitment: CohortResponseTimeCommitment;
  type: CohortType;
  wrapupDate: CohortResponseWrapupDate;
}

export interface CohortTemplate {
  cohortType: string;
  id: number;
}

export interface CohortTemplatesResponse {
  templates: CohortTemplate[];
}

export type CohortType = (typeof CohortType)[keyof typeof CohortType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CohortType = {
  Teams: 'Teams',
  Individual: 'Individual',
  'Individual_-_Assigned': 'Individual - Assigned',
  'Self-Paced_-_Individual': 'Self-Paced - Individual',
} as const;

export type CohortUpdateRequestDescription = string | null;

export type CohortUpdateRequestUrl = string | null;

export interface CohortUpdateRequest {
  applicationEndDate: string;
  applicationStartDate: string;
  available: boolean;
  clientId: number;
  description: CohortUpdateRequestDescription;
  duration: string;
  engagementEndDate: string;
  engagementStartDate: string;
  kickoffDate: string;
  name: string;
  templateId: string;
  timeCommitment: string;
  url: CohortUpdateRequestUrl;
  wrapupDate: string;
}

export type CommunityAnnouncementLink = string | null;

export interface CommunityAnnouncement {
  callToAction: string;
  createdAt: string;
  description: string;
  id: number;
  link: CommunityAnnouncementLink;
  title: string;
  type: AnnouncementTypeEnum;
  updatedAt: string;
}

export type CommunityAnnouncementCreationArgsLink = string | null;

export interface CommunityAnnouncementCreationArgs {
  callToAction: string;
  description: string;
  link: CommunityAnnouncementCreationArgsLink;
  title: string;
  type: AnnouncementTypeEnum;
}

export interface CommunityAnnouncementDeleteArgs {
  id: number;
}

export type CommunityAnnouncementUpdateArgsCallToAction = string | null;

export type CommunityAnnouncementUpdateArgsDescription = string | null;

export type CommunityAnnouncementUpdateArgsLink = string | null;

export type CommunityAnnouncementUpdateArgsTitle = string | null;

export type CommunityAnnouncementUpdateArgsType = AnnouncementTypeEnum | null;

export interface CommunityAnnouncementUpdateArgs {
  callToAction: CommunityAnnouncementUpdateArgsCallToAction;
  description: CommunityAnnouncementUpdateArgsDescription;
  id: number;
  link: CommunityAnnouncementUpdateArgsLink;
  title: CommunityAnnouncementUpdateArgsTitle;
  type: CommunityAnnouncementUpdateArgsType;
}

export interface CommunityMeetingDetail {
  attended: number;
  duration: number;
  filteredRegistrationsCount: number;
  id: number;
  joinUrl: string;
  registered: number;
  registrationRequired: boolean;
  registrations: AdminRegistrationDetail[];
  startTime: string;
  title: string;
  zoomHost: string;
  zoomId: string;
}

export type CommunityWinLink = string | null;

export interface CommunityWin {
  createdAt: string;
  description: string;
  id: number;
  link: CommunityWinLink;
  title: string;
  updatedAt: string;
}

export type CommunityWinCreationArgsLink = string | null;

export interface CommunityWinCreationArgs {
  description: string;
  link: CommunityWinCreationArgsLink;
  title: string;
}

export interface CommunityWinDeleteArgs {
  id: number;
}

export type CommunityWinUpdateArgsDescription = string | null;

export type CommunityWinUpdateArgsLink = string | null;

export type CommunityWinUpdateArgsTitle = string | null;

export interface CommunityWinUpdateArgs {
  description: CommunityWinUpdateArgsDescription;
  id: number;
  link: CommunityWinUpdateArgsLink;
  title: CommunityWinUpdateArgsTitle;
}

export interface ConfirmPasswordRequest {
  password: string;
}

export interface Continent {
  id: number;
  name: string;
}

export type CorporateAdminApplicationStatus = ProfessionalApplicationStatusEnum | null;

export type CorporateAdminAvatar = string | null;

export type CorporateAdminCohort = Cohort | null;

export type CorporateAdminCorporateClientLogo = string | null;

export type CorporateAdminCorporatePartner = string | null;

export type CorporateAdminCorporatePartnerLogo = string | null;

export type CorporateAdminLocation = Location | null;

/**
 * Data for corporate users, much more limited then pros or reps.
 */
export interface CorporateAdmin {
  accountType: 'corporate';
  applicationRoute: string;
  applicationStatus: CorporateAdminApplicationStatus;
  avatar: CorporateAdminAvatar;
  cohort: CorporateAdminCohort;
  corporateClientId: number;
  corporateClientLogo: CorporateAdminCorporateClientLogo;
  corporateClientName: string;
  corporatePartner: CorporateAdminCorporatePartner;
  corporatePartnerLogo: CorporateAdminCorporatePartnerLogo;
  firstName: string;
  lastName: string;
  location: CorporateAdminLocation;
  role: string;
  tocAgreed: boolean;
  userId: number;
  userName: string;
}

/**
 * Represents a limited set of my projects statuses from CardStatusEnum
 */
export type CorporateAdminMatchStatus =
  (typeof CorporateAdminMatchStatus)[keyof typeof CorporateAdminMatchStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CorporateAdminMatchStatus = {
  discovery: 'discovery',
  planning: 'planning',
  action: 'action',
  reflect: 'reflect',
  complete: 'complete',
} as const;

export interface Country {
  id: number;
  name: string;
}

export interface CreateDemoCohortRequest {
  corporateClientId: number;
}

export interface CreateDemoCohortResponse {
  cohortId: number;
  cohortName: string;
}

export interface CreateDemoCommunityAnnouncementRequest {
  type: AnnouncementTypeEnum;
}

export interface CreateDemoCommunityAnnouncementResponse {
  communityAnnouncementId: number;
  title: string;
  type: AnnouncementTypeEnum;
}

export interface CreateDemoCommunityWinResponse {
  communityWinId: number;
  title: string;
}

export interface CreateDemoEventRequest {
  isStatic: boolean;
}

export interface CreateDemoEventResponse {
  endTime: string;
  eventId: number;
  startTime: string;
  title: string;
}

export interface CreateDemoFundingOpportunityResponse {
  fundingOpportunityId: number;
  title: string;
}

export interface CreateDemoJobPostingResponse {
  jobPostingId: number;
  title: string;
}

export interface CreateDemoMatchRequest {
  professionalId: number;
  projectId: number;
}

export interface CreateDemoMatchResponse {
  assignmentId: number;
  professionalId: number;
  projectId: number;
}

export type CreateDemoOrganizationRequestApplicationStatus =
  OrganizationApplicationStatusEnum | null;

export interface CreateDemoOrganizationRequest {
  applicationStatus: CreateDemoOrganizationRequestApplicationStatus;
}

export type CreateDemoOrganizationResponseApplicationStatus =
  OrganizationApplicationStatusEnum | null;

export interface CreateDemoOrganizationResponse {
  applicationStatus: CreateDemoOrganizationResponseApplicationStatus;
  organizationId: number;
  organizationName: string;
  representativeId: number;
  representativeName: string;
}

export type CreateDemoProjectRequestRoleType = ProjectRoleType | null;

export interface CreateDemoProjectRequest {
  representativeId: number;
  roleType: CreateDemoProjectRequestRoleType;
}

export interface CreateDemoProjectResponse {
  organizationId: number;
  projectId: number;
  projectName: string;
}

export type CreateDemoTeamMatchRequestCohortId = number | null;

export interface CreateDemoTeamMatchRequest {
  cohortId: CreateDemoTeamMatchRequestCohortId;
  projectId: number;
}

export interface CreateDemoTeamMatchResponse {
  cohortId: number;
  memberIds: number[];
  projectId: number;
  teamId: number;
  teamLeaderId: number;
}

export type CreateDemoUserRequestApplicationStatus = ProfessionalApplicationStatusEnum | null;

export type CreateDemoUserRequestCohortId = number | null;

export type CreateDemoUserRequestOrganizationId = number | null;

export type CreateDemoUserRequestRole =
  (typeof CreateDemoUserRequestRole)[keyof typeof CreateDemoUserRequestRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDemoUserRequestRole = {
  professional: 'professional',
  representative: 'representative',
  admin: 'admin',
} as const;

export interface CreateDemoUserRequest {
  applicationStatus: CreateDemoUserRequestApplicationStatus;
  cohortId: CreateDemoUserRequestCohortId;
  organizationId: CreateDemoUserRequestOrganizationId;
  role: CreateDemoUserRequestRole;
}

export type CreateDemoUserResponseApplicationStatus = ProfessionalApplicationStatusEnum | null;

export type CreateDemoUserResponseCohortId = number | null;

export interface CreateDemoUserResponse {
  applicationStatus: CreateDemoUserResponseApplicationStatus;
  cohortId: CreateDemoUserResponseCohortId;
  email: string;
  name: string;
  userId: number;
}

export interface CreateProjectFromSuggestionResponse {
  projectId: number;
}

export type CreateProjectRequestCohorts = string[] | null;

export type CreateProjectRequestLearningOutcomes = string | null;

export type CreateProjectRequestName = string | null;

export type CreateProjectRequestSuggestionId = number | null;

export interface CreateProjectRequest {
  businessChallenge: string;
  cohorts: CreateProjectRequestCohorts;
  deliverables: string[];
  description: string;
  learningOutcomes: CreateProjectRequestLearningOutcomes;
  name: CreateProjectRequestName;
  roleTypes: ProjectRoleType[];
  skills: string[];
  suggestionId: CreateProjectRequestSuggestionId;
}

export type CreateProjectRequestOldCohorts = string[] | null;

export type CreateProjectRequestOldDescription = string | null;

export type CreateProjectRequestOldName = string | null;

export interface CreateProjectRequestOld {
  businessChallenge: string;
  cohorts: CreateProjectRequestOldCohorts;
  description?: CreateProjectRequestOldDescription;
  name?: CreateProjectRequestOldName;
  skills: string[];
  supportTypeInfo: SupportTypeInfoItem[];
}

export interface CreateTeamRequest {
  cohortId: number;
  memberIds: number[];
}

export interface CreateTeamResponse {
  status: string;
  teamId: number;
}

export interface DeclineIntroductionRequest {
  introductionId: number;
  reasonId: number;
  status: 'rejected';
}

export type DeleteChallengeRequestChallengeNumber =
  (typeof DeleteChallengeRequestChallengeNumber)[keyof typeof DeleteChallengeRequestChallengeNumber];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteChallengeRequestChallengeNumber = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;

export interface DeleteChallengeRequest {
  challenge_number: DeleteChallengeRequestChallengeNumber;
}

export interface DeleteIntroductionRequest {
  introductionId: number;
}

export type DepartmentEnum = (typeof DepartmentEnum)[keyof typeof DepartmentEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DepartmentEnum = {
  finance: 'finance',
  'global-services': 'global-services',
  legal: 'legal',
  'people-culture': 'people-culture',
  product: 'product',
  sales: 'sales',
  'product-marketing': 'product-marketing',
} as const;

export type DirectoryBaseOrgInfoApplicationStatus = OrganizationApplicationStatusEnum | null;

export type DirectoryBaseOrgInfoAvatarUrl = string | null;

export type DirectoryBaseOrgInfoDateEstablished = string | null;

export type DirectoryBaseOrgInfoLinkedinName = string | null;

export type DirectoryBaseOrgInfoTeamSize = string | null;

/**
 * Base class for organization information used in both org and project profiles.
 */
export interface DirectoryBaseOrgInfo {
  applicationStatus: DirectoryBaseOrgInfoApplicationStatus;
  avatarUrl: DirectoryBaseOrgInfoAvatarUrl;
  dateEstablished: DirectoryBaseOrgInfoDateEstablished;
  industries: string[];
  linkedinName: DirectoryBaseOrgInfoLinkedinName;
  locationCity: string;
  locationCountry: string;
  orgName: string;
  organizationType: string;
  problemStatement: string;
  solutionDescription: string;
  sustainabilityGoals: string[];
  teamSize: DirectoryBaseOrgInfoTeamSize;
  websiteUrl: string;
}

export type DirectoryOrgRepInfoIsProjectLead = boolean | null;

export interface DirectoryOrgRepInfo {
  avatarUrl: string;
  city: string;
  country: string;
  id: number;
  isProjectLead: DirectoryOrgRepInfoIsProjectLead;
  languages: string[];
  linkedinName: string;
  name: string;
  title: string;
}

export type DiscoveryCallMatchedElsewhereUpdateRequestAdditionalDetails = string | null;

export interface DiscoveryCallMatchedElsewhereUpdateRequest {
  additionalDetails: DiscoveryCallMatchedElsewhereUpdateRequestAdditionalDetails;
  introductionId: number;
  updateType: 'matched-elsewhere';
}

export interface DiscoveryCallNeedHelpUpdateRequest {
  additionalDetails: string;
  introductionId: number;
  outcome: 'need-help';
  updateType: 'discovery-completed';
}

export interface DiscoveryCallOtherUpdateRequest {
  additionalDetails: string;
  introductionId: number;
  updateType: 'other';
}

export type DiscoveryCallProAcceptedRequestAdditionalDetails = string | null;

export type DiscoveryCallProAcceptedRequestProjectName = string | null;

export interface DiscoveryCallProAcceptedRequest {
  additionalDetails: DiscoveryCallProAcceptedRequestAdditionalDetails;
  endDate: string;
  introductionId: number;
  outcome: 'accepted-pro';
  projectName: DiscoveryCallProAcceptedRequestProjectName;
  startDate: string;
  updateType: 'discovery-completed';
}

export type DiscoveryCallRejectedRequestAdditionalDetails = string | null;

export type DiscoveryCallRejectedRequestRequestedMatchingSupport = boolean | null;

export interface DiscoveryCallRejectedRequest {
  additionalDetails: DiscoveryCallRejectedRequestAdditionalDetails;
  introductionId: number;
  outcome: 'declined';
  reason: AssignmentDeclinedReason;
  requestedMatchingSupport: DiscoveryCallRejectedRequestRequestedMatchingSupport;
  updateType: 'discovery-completed';
}

export type DiscoveryCallRepAcceptedRequestAdditionalDetails = string | null;

/**
 * Org rep acceptances are handled differently than pro acceptances; they do not choose project names when
one is missing ("custom projects"), nor set start/end dates. Reps are not actually required to accept
Discovery for the project proceed, so this step is essentially just for tracking.
 */
export interface DiscoveryCallRepAcceptedRequest {
  additionalDetails: DiscoveryCallRepAcceptedRequestAdditionalDetails;
  introductionId: number;
  outcome: 'accepted-rep';
  updateType: 'discovery-completed';
}

export type DiscoveryCallScheduledUpdateRequestAdditionalDetails = string | null;

export interface DiscoveryCallScheduledUpdateRequest {
  additionalDetails: DiscoveryCallScheduledUpdateRequestAdditionalDetails;
  callDate: string;
  introductionId: number;
  updateType: 'discovery-scheduled';
}

export type DiscoveryCallStillDecidingUpdateRequestAdditionalDetails = string | null;

export interface DiscoveryCallStillDecidingUpdateRequest {
  additionalDetails: DiscoveryCallStillDecidingUpdateRequestAdditionalDetails;
  introductionId: number;
  updateType: 'still-deciding';
}

export interface DiscoveryCallUnresponsiveUpdateRequest {
  additionalDetails: string;
  introductionId: number;
  updateType: 'unresponsive';
}

export type DiscoveryDecision = (typeof DiscoveryDecision)[keyof typeof DiscoveryDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscoveryDecision = {
  pending: 'pending',
  accepted: 'accepted',
  declined: 'declined',
  unresponsive: 'unresponsive',
} as const;

export interface DiscoveryReminderEightDaysProPayload {
  email_type?: 'DISCOVERY_REMINDER_EIGHT_DAYS_PRO';
  introduction_id: number;
}

export interface DiscoveryReminderEightDaysRepPayload {
  email_type?: 'DISCOVERY_REMINDER_EIGHT_DAYS_REP';
  introduction_id: number;
}

export interface DiscoveryReminderSixteenDaysProPayload {
  email_type?: 'DISCOVERY_REMINDER_SIXTEEN_DAYS_PRO';
  introduction_id: number;
}

export interface DiscoveryReminderSixteenDaysRepPayload {
  email_type?: 'DISCOVERY_REMINDER_SIXTEEN_DAYS_REP';
  introduction_id: number;
}

export interface DiscoveryReminderTwelveDaysProPayload {
  email_type?: 'DISCOVERY_REMINDER_TWELVE_DAYS_PRO';
  introduction_id: number;
}

export interface DiscoveryReminderTwelveDaysRepPayload {
  email_type?: 'DISCOVERY_REMINDER_TWELVE_DAYS_REP';
  introduction_id: number;
}

export interface DiscoveryUpdate {
  createdAt: string;
  id: number;
  updateType: DiscoveryUpdateTypeEnum;
  userId: number;
}

export type DiscoveryUpdateTypeEnum =
  (typeof DiscoveryUpdateTypeEnum)[keyof typeof DiscoveryUpdateTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscoveryUpdateTypeEnum = {
  need_help: 'need_help',
  unresponsive: 'unresponsive',
  other: 'other',
  matched: 'matched',
  not_a_good_fit: 'not_a_good_fit',
  scheduled: 'scheduled',
  still_deciding: 'still_deciding',
  matched_elsewhere: 'matched_elsewhere',
} as const;

export type DroppedApplicantDataMatchData = ApplicantMatchData | null;

export type DroppedApplicantDataMatchStatus = CorporateAdminMatchStatus | null;

export interface DroppedApplicantData {
  droppedDate: string;
  email: string;
  id: number;
  matchData: DroppedApplicantDataMatchData;
  matchStatus: DroppedApplicantDataMatchStatus;
  name: string;
}

export type EIRMeetingDetailNotes = string | null;

export type EIRMeetingDetailOrganization = EIRMeetingOrgDetail | null;

export type EIRMeetingDetailUser = EIRMeetingUserDetail | null;

export interface EIRMeetingDetail {
  attended: boolean;
  duration: number;
  id: number;
  joinUrl: string;
  notes: EIRMeetingDetailNotes;
  organization: EIRMeetingDetailOrganization;
  registered: number;
  registrantEmail: string;
  registrantName: string;
  registrationId: number;
  registrationRequired: boolean;
  startTime: string;
  title: string;
  user: EIRMeetingDetailUser;
  zoomHost: string;
  zoomId: string;
}

export type EIRMeetingOrgChallengesChallengeThree = string | null;

export type EIRMeetingOrgChallengesChallengeTwo = string | null;

export type EIRMeetingOrgChallengesContextThree = string | null;

export type EIRMeetingOrgChallengesContextTwo = string | null;

export interface EIRMeetingOrgChallenges {
  challengeOne: string;
  challengeThree: EIRMeetingOrgChallengesChallengeThree;
  challengeTwo: EIRMeetingOrgChallengesChallengeTwo;
  contextOne: string;
  contextThree: EIRMeetingOrgChallengesContextThree;
  contextTwo: EIRMeetingOrgChallengesContextTwo;
  createdAt: string;
}

export type EIRMeetingOrgDetailBusinessChallenges = EIRMeetingOrgChallenges[] | null;

export type EIRMeetingOrgDetailProjects = EIRMeetingOrgProject[] | null;

export type EIRMeetingOrgDetailWebsite = string | null;

export interface EIRMeetingOrgDetail {
  businessChallenges: EIRMeetingOrgDetailBusinessChallenges;
  id: number;
  industries: string[];
  name: string;
  projects: EIRMeetingOrgDetailProjects;
  registrationDate: string;
  website: EIRMeetingOrgDetailWebsite;
}

export interface EIRMeetingOrgProject {
  createdAt: string;
  id: number;
  name: string;
}

export interface EIRMeetingUserDetail {
  firstname: string;
  id: number;
  lastname: string;
}

export type EarliestDateAvailableResponseSearchStatus =
  (typeof EarliestDateAvailableResponseSearchStatus)[keyof typeof EarliestDateAvailableResponseSearchStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EarliestDateAvailableResponseSearchStatus = {
  Active_Team: 'Active Team',
  Active_Seeking: 'Active Seeking',
  Open_to_Intro: 'Open to Intro',
} as const;

export interface EarliestDateAvailableResponse {
  earliestDateAvailable: string;
  searchStatus: EarliestDateAvailableResponseSearchStatus;
}

export type EditProjectRequestCohorts = string[] | null;

export type EditProjectRequestDeliverables = string[] | null;

export type EditProjectRequestGoals = string | null;

export type EditProjectRequestLearningOutcomes = string | null;

export interface EditProjectRequest {
  businessChallenge: string;
  cohorts: EditProjectRequestCohorts;
  deliverables: EditProjectRequestDeliverables;
  description: string;
  goals: EditProjectRequestGoals;
  languages: string[];
  learningOutcomes: EditProjectRequestLearningOutcomes;
  name: string;
  roleType: ProjectRoleType;
  skills: string[];
}

export type EventLink = string | null;

export interface Event {
  createdAt: string;
  description: string;
  endTime: string;
  hostedBy: string;
  id: number;
  link: EventLink;
  startTime: string;
  timezone: string;
  title: string;
  updatedAt: string;
}

export type EventCreationArgsLink = string | null;

export interface EventCreationArgs {
  description: string;
  endTime: string;
  hostedBy: string;
  link: EventCreationArgsLink;
  startTime: string;
  timezone: string;
  title: string;
}

export interface EventDeleteArgs {
  id: number;
}

export type EventUpdateArgsDescription = string | null;

export type EventUpdateArgsEndTime = string | null;

export type EventUpdateArgsHostedBy = string | null;

export type EventUpdateArgsLink = string | null;

export type EventUpdateArgsStartTime = string | null;

export type EventUpdateArgsTimezone = string | null;

export type EventUpdateArgsTitle = string | null;

export interface EventUpdateArgs {
  description: EventUpdateArgsDescription;
  endTime: EventUpdateArgsEndTime;
  hostedBy: EventUpdateArgsHostedBy;
  id: number;
  link: EventUpdateArgsLink;
  startTime: EventUpdateArgsStartTime;
  timezone: EventUpdateArgsTimezone;
  title: EventUpdateArgsTitle;
}

export interface EventsCountResponse {
  past: number;
  upcoming: number;
}

/**
 * An enumeration representing the different ranges of years of experience for members in a cohort. These ranges are used to categorize members based on their professional experience.
 */
export type ExperienceYearsRangeEnum =
  (typeof ExperienceYearsRangeEnum)[keyof typeof ExperienceYearsRangeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExperienceYearsRangeEnum = {
  '0-2_years': '0-2 years',
  '3-5_years': '3-5 years',
  '6-10_years': '6-10 years',
  '11+_years': '11+ years',
} as const;

export interface Expertise {
  classification: string;
  id: number;
  name: string;
}

export type F5ApplicationParametersCohortId = number | null;

export type F5ApplicationParametersExperienceHopeOther = string | null;

export type F5ApplicationParametersLinkedin = string | null;

export type F5ApplicationParametersProfilePicture = string | null;

export type F5ApplicationParametersResume = string | null;

export interface F5ApplicationParameters {
  city: string;
  cohortId: F5ApplicationParametersCohortId;
  country: number;
  department: DepartmentEnum;
  experienceHope: ProfessionalExperienceHopeEnum[];
  experienceHopeOther: F5ApplicationParametersExperienceHopeOther;
  impactAreas: string[];
  industries: string[];
  jobTitle: string;
  languages: string[];
  linkedin: F5ApplicationParametersLinkedin;
  profilePicture: F5ApplicationParametersProfilePicture;
  referralMethod: string;
  resume: F5ApplicationParametersResume;
  skills: SkillsExperience[];
  skillsImpact: string;
  theatre: TheatreEnum;
  timezone: string;
  yearsOfExperience: number;
}

export type FundingAmount = (typeof FundingAmount)[keyof typeof FundingAmount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FundingAmount = {
  '10,000_-_50,000': '10,000 - 50,000',
  '50,000_-_100,000': '50,000 - 100,000',
  '100,000_-_250,000': '100,000 - 250,000',
  '250,000_-_500,000': '250,000 - 500,000',
  '500,000_-_1,000,000': '500,000 - 1,000,000',
  '1,000,000_-_2,500,000': '1,000,000 - 2,500,000',
  '2,500,000+': '2,500,000+',
} as const;

export type FundingOpportunityLink = string | null;

export interface FundingOpportunity {
  createdAt: string;
  date: string;
  description: string;
  id: number;
  link: FundingOpportunityLink;
  title: string;
  updatedAt: string;
}

export type FundingOpportunityCreationArgsLink = string | null;

export interface FundingOpportunityCreationArgs {
  date: string;
  description: string;
  link: FundingOpportunityCreationArgsLink;
  title: string;
}

export interface FundingOpportunityDeleteArgs {
  id: number;
}

export type FundingOpportunityUpdateArgsDate = string | null;

export type FundingOpportunityUpdateArgsDescription = string | null;

export type FundingOpportunityUpdateArgsLink = string | null;

export type FundingOpportunityUpdateArgsTitle = string | null;

export interface FundingOpportunityUpdateArgs {
  date: FundingOpportunityUpdateArgsDate;
  description: FundingOpportunityUpdateArgsDescription;
  id: number;
  link: FundingOpportunityUpdateArgsLink;
  title: FundingOpportunityUpdateArgsTitle;
}

export type FundingStatus = (typeof FundingStatus)[keyof typeof FundingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FundingStatus = {
  'no-funding': 'no-funding',
  'grant-funding': 'grant-funding',
  'angel-funding': 'angel-funding',
  'venture-capital-funding': 'venture-capital-funding',
} as const;

export interface GetApplicantsResponse {
  accepted: AcceptedApplicantData[];
  dropped: DroppedApplicantData[];
  pending: PendingApplicantData[];
  rejected: RejectedApplicantData[];
}

export interface GetCohortsByClientsResponse {
  clients: UpdateCohortClient[];
}

export interface GetCohortsResponse {
  cohorts: CohortData[];
}

export type GetExperteerPreferencesResponseEarliestDateAvailable = string | null;

export type GetExperteerPreferencesResponseReason = 'Matched' | 'Opted Out' | 'Postponed' | null;

export interface GetExperteerPreferencesResponse {
  earliestDateAvailable: GetExperteerPreferencesResponseEarliestDateAvailable;
  reason: GetExperteerPreferencesResponseReason;
  searchStatus: SearchStatusEnum;
}

export interface GetFreeAgentsResponse {
  freeAgents: AdminTeamMember[];
  total: number;
}

export interface GetOrganizationProjectsResponse {
  filteredCount: number;
  projects: OrganizationDetailProject[];
}

export interface GetProjectSuggestionResponse {
  projectSuggestion: ProjectSuggestion;
}

export interface GetSimpleCohortsResponse {
  cohorts: SrcRoutersCohortsSimpleCohort[];
}

export interface GetTeamDetailsResponse {
  team: AdminTeamDetailed;
}

export interface GetTeamIdsResponse {
  teamIds: number[];
}

export interface GetTeamMembersResponse {
  members: AdminTeamMember[];
}

export interface GetTeamsCountsResponse {
  cohortName: string;
  freeAgentsCount: number;
  teamsCount: number;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export const HiddenIntroCTAStateValue = {
  state: 'hidden',
} as const;
export type HiddenIntroCTAState = typeof HiddenIntroCTAStateValue;

export type HubActionDataActionCompletedDate = string | null;

export interface HubActionData {
  actionCompletedDate: HubActionDataActionCompletedDate;
  actionUpdates: UserActionUpdate[];
}

export type HubContactCardAvatar = string | null;

export interface HubContactCard {
  avatar: HubContactCardAvatar;
  email: string;
  firstname: string;
  id: number;
  lastname: string;
}

export type HubDiscoveryDiscoveryUpdates = DiscoveryUpdate[] | null;

export interface HubDiscovery {
  discoveryUpdates: HubDiscoveryDiscoveryUpdates;
  id: number;
  updatedAt: string;
}

export interface HubIntroduction {
  acceptedDate: string;
  id: number;
  initiationType: string;
  message: string;
  sentDate: string;
}

export type HubOrganizationAvatar = string | null;

export interface HubOrganization {
  avatar: HubOrganizationAvatar;
  id: number;
  name: string;
}

export interface HubProgressResponse {
  action: ProgressStepStatusEnum;
  discovery: ProgressStepStatusEnum;
  introduction: ProgressStepStatusEnum;
  planning: ProgressStepStatusEnum;
  reflect: ProgressStepStatusEnum;
}

export type HubProjectEndDate = string | null;

export type HubProjectName = string | null;

export type HubProjectStartDate = string | null;

export interface HubProject {
  endDate: HubProjectEndDate;
  id: number;
  name: HubProjectName;
  roleType: ProjectRoleType;
  startDate: HubProjectStartDate;
}

export type HubStatusEnum = (typeof HubStatusEnum)[keyof typeof HubStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HubStatusEnum = {
  Matched: 'Matched',
  Connected: 'Connected',
  Complete: 'Complete',
} as const;

export type ImpactPartnerInfoDescription = string | null;

export type ImpactPartnerInfoLogo = string | null;

export type ImpactPartnerInfoUrlParam = string | null;

export interface ImpactPartnerInfo {
  description: ImpactPartnerInfoDescription;
  id: number;
  logo: ImpactPartnerInfoLogo;
  name: string;
  urlParam: ImpactPartnerInfoUrlParam;
}

export interface ImpactPartnerResponse {
  impactPartner: ImpactPartnerInfo;
  orgs: OrgCard[];
}

export type IndividualApplicationParametersCohortId = number | null;

export type IndividualApplicationParametersExperienceHopeOther = string | null;

export type IndividualApplicationParametersLinkedin = string | null;

export type IndividualApplicationParametersProfilePicture = string | null;

export type IndividualApplicationParametersResume = string | null;

export interface IndividualApplicationParameters {
  city: string;
  cohortId: IndividualApplicationParametersCohortId;
  country: number;
  currentEmployer: string;
  experienceHope: ProfessionalExperienceHopeEnum[];
  experienceHopeOther: IndividualApplicationParametersExperienceHopeOther;
  hasWorkedAtSap: boolean;
  impactAreas: string[];
  industries: string[];
  jobTitle: string;
  languages: string[];
  linkedin: IndividualApplicationParametersLinkedin;
  profilePicture: IndividualApplicationParametersProfilePicture;
  referralMethod: string;
  resume: IndividualApplicationParametersResume;
  skills: SkillsExperience[];
  skillsImpact: string;
  timezone: string;
  yearsOfExperience: number;
}

export interface IndividualMatchConfirmationPayload {
  assignment_id: number;
  email_type?: 'PROJECT_MATCHED_INDIVIDUAL';
}

export interface Industry {
  classification: string;
  id: number;
  name: string;
}

export type IntroActionUpdateNotes = string | null;

export type IntroActionUpdateUserType =
  (typeof IntroActionUpdateUserType)[keyof typeof IntroActionUpdateUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntroActionUpdateUserType = {
  representative: 'representative',
  professional: 'professional',
  admin: 'admin',
} as const;

export interface IntroActionUpdate {
  notes: IntroActionUpdateNotes;
  outcome: ActionUpdateOutcomeEnum;
  updateDate: string;
  userName: string;
  userType: IntroActionUpdateUserType;
}

export type IntroDiscoveryUpdateNotes = string | null;

export type IntroDiscoveryUpdateUserType =
  (typeof IntroDiscoveryUpdateUserType)[keyof typeof IntroDiscoveryUpdateUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntroDiscoveryUpdateUserType = {
  representative: 'representative',
  professional: 'professional',
} as const;

export interface IntroDiscoveryUpdate {
  notes: IntroDiscoveryUpdateNotes;
  updateDate: string;
  updateType: DiscoveryUpdateTypeEnum;
  userName: string;
  userType: IntroDiscoveryUpdateUserType;
}

export type IntroPlanUpdateNotes = string | null;

export type IntroPlanUpdateUserType =
  (typeof IntroPlanUpdateUserType)[keyof typeof IntroPlanUpdateUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntroPlanUpdateUserType = {
  representative: 'representative',
  professional: 'professional',
  admin: 'admin',
} as const;

export interface IntroPlanUpdate {
  notes: IntroPlanUpdateNotes;
  outcome: PlanningUpdateOutcomeEnum;
  updateDate: string;
  userName: string;
  userType: IntroPlanUpdateUserType;
}

export interface IntroductionCohort {
  id: number;
  name: string;
}

export type IntroductionCreateRequestInitiationType =
  (typeof IntroductionCreateRequestInitiationType)[keyof typeof IntroductionCreateRequestInitiationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntroductionCreateRequestInitiationType = {
  Experteer: 'Experteer',
  Organization: 'Organization',
} as const;

export type IntroductionCreateRequestProjectId = number | null;

export type IntroductionCreateRequestRepresentativeId = number | null;

export type IntroductionCreateRequestScheduledSendDate = string | null;

export interface IntroductionCreateRequest {
  initiationType: IntroductionCreateRequestInitiationType;
  personalMessage: string;
  professionalId: number;
  projectId: IntroductionCreateRequestProjectId;
  representativeId: IntroductionCreateRequestRepresentativeId;
  scheduledSendDate?: IntroductionCreateRequestScheduledSendDate;
}

export type IntroductionDetailResponseActionUpdates = IntroActionUpdate[] | null;

export type IntroductionDetailResponseDiscoveryUpdates = IntroDiscoveryUpdate[] | null;

export type IntroductionDetailResponseIntroduction = IntroductionDetails | null;

export type IntroductionDetailResponsePlanUpdates = IntroPlanUpdate[] | null;

export type IntroductionDetailResponseProjectPlan = AdminProjectPlan | null;

export interface IntroductionDetailResponse {
  actionUpdates: IntroductionDetailResponseActionUpdates;
  discoveryUpdates: IntroductionDetailResponseDiscoveryUpdates;
  introduction: IntroductionDetailResponseIntroduction;
  planUpdates: IntroductionDetailResponsePlanUpdates;
  projectPlan: IntroductionDetailResponseProjectPlan;
}

export type IntroductionDetailsCohort = IntroductionCohort | null;

export type IntroductionDetailsDiscovery = IntroductionDiscovery | null;

export type IntroductionDetailsPlanningGuideUrl = string | null;

export type IntroductionDetailsProject = IntroductionProject | null;

export type IntroductionDetailsProjectPlanId = number | null;

export type IntroductionDetailsReasonId = number | null;

export interface IntroductionDetails {
  cohort: IntroductionDetailsCohort;
  createdAt: string;
  discovery: IntroductionDetailsDiscovery;
  id: number;
  initiationType: string;
  message: string;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  organization: IntroductionOrganization;
  outcome: IntroductionOutcomeEnum;
  planningGuideUrl: IntroductionDetailsPlanningGuideUrl;
  professional: IntroductionProfessional;
  project: IntroductionDetailsProject;
  projectPlanId: IntroductionDetailsProjectPlanId;
  reasonId: IntroductionDetailsReasonId;
  representative: IntroductionRepresentative;
}

export type IntroductionDiscoveryCallDate = string | null;

export type IntroductionDiscoveryOrganizationDecision = DiscoveryDecision | null;

export type IntroductionDiscoveryOrganizationReason = AssignmentDeclinedReason | null;

export type IntroductionDiscoveryProfessionalDecision = DiscoveryDecision | null;

export type IntroductionDiscoveryProfessionalReason = AssignmentDeclinedReason | null;

export interface IntroductionDiscovery {
  callDate: IntroductionDiscoveryCallDate;
  id: number;
  organizationDecision: IntroductionDiscoveryOrganizationDecision;
  organizationReason: IntroductionDiscoveryOrganizationReason;
  professionalDecision: IntroductionDiscoveryProfessionalDecision;
  professionalReason: IntroductionDiscoveryProfessionalReason;
}

export interface IntroductionOrganization {
  id: number;
  name: string;
}

export type IntroductionOutcomeEnum =
  (typeof IntroductionOutcomeEnum)[keyof typeof IntroductionOutcomeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntroductionOutcomeEnum = {
  pending: 'pending',
  accepted: 'accepted',
  declined: 'declined',
  withdrawn: 'withdrawn',
  expired: 'expired',
} as const;

export interface IntroductionProToRepPayload {
  email_type?: 'INTRO_PRO_TO_REP';
  introduction_id: number;
  user_id: number;
}

export interface IntroductionProToRepReminderFourDaysPayload {
  email_type?: 'INTRO_PRO_TO_REP_REMINDER_FOUR_DAYS';
  introduction_id: number;
  user_id: number;
}

export interface IntroductionProToRepReminderSevenDaysPayload {
  email_type?: 'INTRO_PRO_TO_REP_REMINDER_SEVEN_DAYS';
  introduction_id: number;
  user_id: number;
}

export interface IntroductionProfessional {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
}

export type IntroductionProjectEndDate = string | null;

export type IntroductionProjectStartDate = string | null;

export interface IntroductionProject {
  endDate: IntroductionProjectEndDate;
  id: number;
  name: string;
  startDate: IntroductionProjectStartDate;
}

export interface IntroductionRepToProPayload {
  email_type?: 'INTRO_REP_TO_PRO';
  introduction_id: number;
  user_id: number;
}

export interface IntroductionRepToProReminderFourDaysPayload {
  email_type?: 'INTRO_REP_TO_PRO_REMINDER_FOUR_DAYS';
  introduction_id: number;
  user_id: number;
}

export interface IntroductionRepToProReminderSevenDaysPayload {
  email_type?: 'INTRO_REP_TO_PRO_REMINDER_SEVEN_DAYS';
  introduction_id: number;
  user_id: number;
}

export interface IntroductionRepresentative {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
}

export type IntroductionStatusEnum =
  (typeof IntroductionStatusEnum)[keyof typeof IntroductionStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IntroductionStatusEnum = {
  requested: 'requested',
  'intro-request-one': 'intro-request-one',
  'intro-request-two': 'intro-request-two',
  'intro-request-three': 'intro-request-three',
  'mutual-intro-one': 'mutual-intro-one',
  'mutual-intro-two': 'mutual-intro-two',
  'mutual-intro-three': 'mutual-intro-three',
  rejected: 'rejected',
  unresponsive: 'unresponsive',
  withdrawn: 'withdrawn',
  inactive: 'inactive',
  matched: 'matched',
  'matched-two': 'matched-two',
  'matched-withdrawn': 'matched-withdrawn',
  'matched-offplatform': 'matched-offplatform',
  'automatch-propose': 'automatch-propose',
  'automatch-to-cancel': 'automatch-to-cancel',
  'automatch-cancelled': 'automatch-cancelled',
  'request-on-hold': 'request-on-hold',
  'request-review': 'request-review',
} as const;

export type JobData =
  | DiscoveryReminderEightDaysProPayload
  | DiscoveryReminderTwelveDaysProPayload
  | DiscoveryReminderSixteenDaysProPayload
  | DiscoveryReminderEightDaysRepPayload
  | DiscoveryReminderTwelveDaysRepPayload
  | DiscoveryReminderSixteenDaysRepPayload
  | PostMatchNewProjectThirtyDaysRepPayload
  | PostMatchSurveyOneDayProPayload
  | PostMatchSurveyFourteenDaysProPayload
  | PostMatchSurveyOneDayRepPayload
  | PostMatchSurveyFourteenDaysRepPayload
  | OrgOnboardOneDayPayload
  | OrgOnboardTwoDaysPayload
  | OrgOnboardThreeDaysPayload
  | OrgOnboardEightDaysPayload
  | OrgOnboardTenDaysNoProjectPayload
  | OrgOnboardTwentyDaysNoProjectPayload
  | ProOnboardOneDayPayload
  | ProOnboardTwoDaysPayload
  | TeamPostMatchSurveyOneDayProPayload
  | TeamPostMatchSurveyFourteenDaysProPayload
  | TeamPostMatchSurveyOneDayRepPayload
  | TeamPostMatchSurveyFourteenDaysRepPayload
  | ProjectPlanIncompleteTenDaysPayload
  | ProjectPlanIncompleteTenDaysPayloadV2
  | ProjectPlanIncompleteFifteenDaysPayload
  | ProjectPlanIncompleteFifteenDaysPayloadV2
  | ProjectActionIncompleteMinusSevenDaysPayload
  | ProjectActionIncompletePayload
  | ProjectActionIncompletePlusSevenDaysPayload
  | TeamProjectPlanIncompleteTenDaysPayload
  | TeamProjectPlanIncompleteFifteenDaysPayload
  | TeamProjectPlanIncompleteTenDaysPayloadV2
  | TeamProjectPlanIncompleteFifteenDaysPayloadV2
  | TeamProjectActionIncompleteMinusSevenDaysPayload
  | TeamProjectActionIncompletePayload
  | TeamProjectActionIncompletePlusSevenDaysPayload
  | AcceptedIntroPayload
  | SuggestedProjectPayload
  | TeamMatchConfirmationPayload
  | IntroductionProToRepPayload
  | IntroductionProToRepReminderFourDaysPayload
  | IntroductionProToRepReminderSevenDaysPayload
  | IntroductionRepToProPayload
  | IntroductionRepToProReminderFourDaysPayload
  | IntroductionRepToProReminderSevenDaysPayload
  | IndividualMatchConfirmationPayload;

/**
 * Base class for all jobs
 */
export interface Job {
  data: JobData;
  target_datetime: string;
  type: JobType;
}

export type JobPostingLocation = string | null;

export type JobPostingUrl = string | null;

export interface JobPosting {
  createdAt: string;
  date: string;
  description: string;
  id: number;
  location: JobPostingLocation;
  title: string;
  updatedAt: string;
  url: JobPostingUrl;
}

export type JobPostingCreationArgsLocation = string | null;

export type JobPostingCreationArgsUrl = string | null;

export interface JobPostingCreationArgs {
  date: string;
  description: string;
  location: JobPostingCreationArgsLocation;
  title: string;
  url: JobPostingCreationArgsUrl;
}

export interface JobPostingDeleteArgs {
  id: number;
}

export type JobPostingUpdateArgsDate = string | null;

export type JobPostingUpdateArgsDescription = string | null;

export type JobPostingUpdateArgsLocation = string | null;

export type JobPostingUpdateArgsTitle = string | null;

export type JobPostingUpdateArgsUrl = string | null;

export interface JobPostingUpdateArgs {
  date: JobPostingUpdateArgsDate;
  description: JobPostingUpdateArgsDescription;
  id: number;
  location: JobPostingUpdateArgsLocation;
  title: JobPostingUpdateArgsTitle;
  url: JobPostingUpdateArgsUrl;
}

/**
 * Enum describing all different possible kinds of jobs
 */
export type JobType = (typeof JobType)[keyof typeof JobType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobType = {
  email: 'email',
} as const;

export interface Language {
  id: number;
  name: string;
}

export type LocationCity = string | null;

export type LocationCountry = string | null;

export type LocationCountryCode = string | null;

export type LocationLatitude = number | null;

export type LocationLongitude = number | null;

export type LocationState = string | null;

export interface Location {
  city: LocationCity;
  country: LocationCountry;
  countryCode: LocationCountryCode;
  latitude: LocationLatitude;
  longitude: LocationLongitude;
  state: LocationState;
}

export interface LoginParameters {
  email: string;
  password: string;
}

export type LumenApplicationParametersCohortId = number | null;

export type LumenApplicationParametersExperienceHopeOther = string | null;

export type LumenApplicationParametersLinkedin = string | null;

export type LumenApplicationParametersPreviousVolunteerExperience = string | null;

export type LumenApplicationParametersProfilePicture = string | null;

export type LumenApplicationParametersResume = string | null;

export interface LumenApplicationParameters {
  city: string;
  cohortId: LumenApplicationParametersCohortId;
  country: number;
  experienceHope: ProfessionalExperienceHopeEnum[];
  experienceHopeOther: LumenApplicationParametersExperienceHopeOther;
  impactAreas: string[];
  industries: string[];
  jobTitle: string;
  languages: string[];
  linkedin: LumenApplicationParametersLinkedin;
  previousVolunteerExperience: LumenApplicationParametersPreviousVolunteerExperience;
  profilePicture: LumenApplicationParametersProfilePicture;
  referralMethod: string;
  repeatVolunteer: string;
  resume: LumenApplicationParametersResume;
  skills: SkillsExperience[];
  skillsImpact: string;
  timezone: string;
  yearsOfExperience: number;
}

export interface LumenSubmissionResponse {
  applicationsClosed: boolean;
  status: ProfessionalApplicationStatusEnum;
}

export type MatchedIntroCTAStateDetails = SentIntroDetails | null;

export interface MatchedIntroCTAState {
  details: MatchedIntroCTAStateDetails;
  state: 'matched';
}

export interface MicrostoryDeleteArgs {
  id: number;
}

export type MicrostoryDetailsCorporateClientId = number | null;

export type MicrostoryDetailsImpactPartnerId = number | null;

export type MicrostoryDetailsOrganizationId = number | null;

export type MicrostoryDetailsOrganizationName = string | null;

export type MicrostoryDetailsUrlOrFileRef = string | null;

export type MicrostoryDetailsUserId = number | null;

export type MicrostoryDetailsUserType = SimplifiedUserRole | null;

export interface MicrostoryDetails {
  consentToShare: boolean;
  contactName: string;
  corporateClientId: MicrostoryDetailsCorporateClientId;
  impactPartnerId: MicrostoryDetailsImpactPartnerId;
  microstory: string;
  organizationId: MicrostoryDetailsOrganizationId;
  organizationName: MicrostoryDetailsOrganizationName;
  source: MicrostorySource;
  storyDate: string;
  urlOrFileRef: MicrostoryDetailsUrlOrFileRef;
  userId: MicrostoryDetailsUserId;
  userType: MicrostoryDetailsUserType;
}

export interface MicrostoryFilterOptionsResponse {
  corporateClients: MicrostoryPartnerOption[];
  impactPartners: MicrostoryPartnerOption[];
}

export interface MicrostoryPartnerOption {
  id: number;
  name: string;
}

export type MicrostorySource = (typeof MicrostorySource)[keyof typeof MicrostorySource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MicrostorySource = {
  end_of_project_survey: 'end_of_project_survey',
  direct: 'direct',
  midpoint_email: 'midpoint_email',
  social_media: 'social_media',
  other: 'other',
  corporate_launch_survey: 'corporate_launch_survey',
  story_submission: 'story_submission',
  platform_submission: 'platform_submission',
} as const;

export type MicrostorySubmissionUrl = string | null;

export interface MicrostorySubmission {
  consentToShare: boolean;
  microstory: string;
  projectId: number;
  url: MicrostorySubmissionUrl;
}

export type MyCohortMemberDetailAvatarUrl = string | null;

export type MyCohortMemberDetailCountry = string | null;

export type MyCohortMemberDetailCountryIso3166Alpha2 = string | null;

export type MyCohortMemberDetailEmployer = string | null;

export type MyCohortMemberDetailPositionTitle = string | null;

/**
 * Represents a member of a cohort including information used to support the member cards on 'My Cohort' page.
 */
export interface MyCohortMemberDetail {
  avatarUrl: MyCohortMemberDetailAvatarUrl;
  country: MyCohortMemberDetailCountry;
  countryIso3166Alpha2: MyCohortMemberDetailCountryIso3166Alpha2;
  employer: MyCohortMemberDetailEmployer;
  firstName: string;
  lastName: string;
  positionTitle: MyCohortMemberDetailPositionTitle;
  skills: string[];
  userId: number;
}

export type MyCohortPreviewMemberAvatarUrl = string | null;

/**
 * Represents a member of a cohort for preview purposes, including their avatar URL and name. This is used to display a limited number of cohort members in the UI.
 */
export interface MyCohortPreviewMember {
  avatarUrl: MyCohortPreviewMemberAvatarUrl;
  firstName: string;
  lastName: string;
}

export type MyCohortPreviewResponseProjectHubUrl = string | null;

/**
 * Represents a preview of the current cohort for a given user, including cohort details, a list of members, total member count, current progress stage, and an optional project hub URL. Project hub URL should always be provided if the user has a project assigned, otherwise it will be None. Informs cta to project_hub
 */
export interface MyCohortPreviewResponse {
  cohort: CohortBaseDetail;
  currentProgress: MyCohortProgressEnum;
  members: MyCohortPreviewMember[];
  projectHubUrl: MyCohortPreviewResponseProjectHubUrl;
  totalCount: number;
}

/**
 * An enumeration representing the different stages of progress a user can be in within their cohort. These stages are derived from the cohort's milestone dates and the user's current assignment or team_assignment status.
 */
export type MyCohortProgressEnum = (typeof MyCohortProgressEnum)[keyof typeof MyCohortProgressEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyCohortProgressEnum = {
  kickoff: 'kickoff',
  matching: 'matching',
  planning: 'planning',
  action: 'action',
  reflect: 'reflect',
  wrap_up: 'wrap_up',
} as const;

export type MyCohortResponseExperienceDistribution = { [key: string]: number };

/**
 * Reflects data for a professional's 'My Cohort' page. Includes member details as well as cohort stats for skills, countries, languages and distribution of years_experience across members.
 */
export interface MyCohortResponse {
  clientName: string;
  continentCount: number;
  countryCount: number;
  experienceDistribution: MyCohortResponseExperienceDistribution;
  languageCount: number;
  members: MyCohortMemberDetail[];
  skillsCount: number;
}

export type MyProjectsIntroductionInitiationType =
  (typeof MyProjectsIntroductionInitiationType)[keyof typeof MyProjectsIntroductionInitiationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyProjectsIntroductionInitiationType = {
  Experteer: 'Experteer',
  Organization: 'Organization',
} as const;

export type MyProjectsIntroductionReason = string | null;

export interface MyProjectsIntroduction {
  createdAt: string;
  id: number;
  initiationType: MyProjectsIntroductionInitiationType;
  outcome: IntroductionOutcomeEnum;
  personalMessage: string;
  reason: MyProjectsIntroductionReason;
  statusChangedAt: string;
}

export interface MyProjectsOrganization {
  id: number;
  name: string;
}

export interface MyProjectsProfessional {
  firstname: string;
  id: number;
  lastname: string;
}

export type MyProjectsProjectEndDate = string | null;

export type MyProjectsProjectPublishingStageUpdatedDate = string | null;

export type MyProjectsProjectStartDate = string | null;

export interface MyProjectsProject {
  createdAt: string;
  endDate: MyProjectsProjectEndDate;
  id: number;
  name: string;
  publishingStage: ProjectPublishingStage;
  publishingStageUpdatedDate: MyProjectsProjectPublishingStageUpdatedDate;
  roleType: ProjectRoleType;
  startDate: MyProjectsProjectStartDate;
}

export interface NameSearchOption {
  id: number;
  name: string;
}

export interface NameSearchResponse {
  options: NameSearchOption[];
}

export type NewIntroductionPayloadProjectId = number | null;

/**
 * POST body model for sending an introduction.
 */
export interface NewIntroductionPayload {
  fromRole: SimplifiedUserRole;
  message: string;
  projectId: NewIntroductionPayloadProjectId;
}

export interface NewMember {
  id: number;
  name: string;
}

export interface NewMemberResponse {
  member: NewMember;
}

export type NotSeekingNoDateResponseReason =
  (typeof NotSeekingNoDateResponseReason)[keyof typeof NotSeekingNoDateResponseReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotSeekingNoDateResponseReason = {
  Matched: 'Matched',
  Opted_Out: 'Opted Out',
} as const;

export interface NotSeekingNoDateResponse {
  reason: NotSeekingNoDateResponseReason;
  searchStatus: 'Not Seeking';
}

export interface NotSeekingPostponingResponse {
  earliestDateAvailable: string;
  reason: 'Postponed';
  searchStatus: 'Not Seeking';
}

export interface NotificationRequestResponse {
  currentNotifications: CohortNotification[];
}

export interface OneProjectIntroReceivedIntroCTAState {
  date: string;
  details: SentIntroDetails;
  introId: number;
  projectId: number;
  state: 'one_project_intro_received';
}

export interface OneProjectIntroSentIntroCTAState {
  date: string;
  details: SentIntroDetails;
  introId: number;
  projectId: number;
  state: 'one_project_intro_sent';
}

export type OrgCardLogoUrl = string | null;

export interface OrgCard {
  description: string;
  logoUrl: OrgCardLogoUrl;
  name: string;
  organizationId: number;
}

export type OrgOnboardEightDaysPayloadEmailType =
  'ORG_ONBOARD_EIGHT_DAYS' | 'ORG_ONBOARD_EIGHT_DAYS_NO_NEEDS_FORM';

export interface OrgOnboardEightDaysPayload {
  email_type?: OrgOnboardEightDaysPayloadEmailType;
  rep_user_id: number;
}

export interface OrgOnboardOneDayPayload {
  email_type?: 'ORG_ONBOARD_ONE_DAY';
  rep_user_id: number;
}

export interface OrgOnboardTenDaysNoProjectPayload {
  email_type?: 'ORG_ONBOARD_TEN_DAYS_NO_PROJECT';
  rep_user_id: number;
}

export interface OrgOnboardThreeDaysPayload {
  email_type?: 'ORG_ONBOARD_THREE_DAYS';
  rep_user_id: number;
}

export interface OrgOnboardTwentyDaysNoProjectPayload {
  email_type?: 'ORG_ONBOARD_TWENTY_DAYS_NO_PROJECT';
  rep_user_id: number;
}

export interface OrgOnboardTwoDaysPayload {
  email_type?: 'ORG_ONBOARD_TWO_DAYS';
  rep_user_id: number;
}

export interface OrgProfilePartnerResponse {
  avatarUrl: string;
  name: string;
}

export interface OrgProfileProjectResponse {
  expertises: string[];
  id: string;
  name: string;
  projectType: ProjectRoleType;
}

export type OrgProfileResponseBusinessModel = BusinessModel | null;

export type OrgProfileResponseBusinessModelDescription = string | null;

export type OrgProfileResponseCountries = number[] | null;

export type OrgProfileResponseExperienceHope = OrganizationExperienceHopeEnum[] | null;

export type OrgProfileResponseFunding = FundingStatus[] | null;

export type OrgProfileResponseFundingAmount = FundingAmount | null;

export type OrgProfileResponseHqCountry = number | null;

export type OrgProfileResponseIndustries = string[] | null;

export type OrgProfileResponseLinkedin = string | null;

export type OrgProfileResponseOrgLogo = string | null;

export type OrgProfileResponseOrganizationSize = number | null;

export type OrgProfileResponseOrganizationType = number | null;

export type OrgProfileResponseOtherPartners = string | null;

export type OrgProfileResponsePartners = string[] | null;

export type OrgProfileResponseProblem = string | null;

export type OrgProfileResponseReferralMethod = string | null;

export type OrgProfileResponseRepCity = string | null;

export type OrgProfileResponseRepCountry = number | null;

export type OrgProfileResponseRepJobTitle = string | null;

export type OrgProfileResponseRepLanguages = string[] | null;

export type OrgProfileResponseRepLinkedin = string | null;

export type OrgProfileResponseRepProfilePicture = string | null;

export type OrgProfileResponseRepTimezone = string | null;

export type OrgProfileResponseRevenueAmount = RevenueAmount | null;

export type OrgProfileResponseRevenueGeneration = boolean | null;

export type OrgProfileResponseSdgTracking = string | null;

export type OrgProfileResponseSdgs = string[] | null;

export type OrgProfileResponseSolution = string | null;

export type OrgProfileResponseWebsite = string | null;

export type OrgProfileResponseYearOfRegistration = number | null;

export interface OrgProfileResponse {
  businessModel: OrgProfileResponseBusinessModel;
  businessModelDescription: OrgProfileResponseBusinessModelDescription;
  countries: OrgProfileResponseCountries;
  experienceHope: OrgProfileResponseExperienceHope;
  funding: OrgProfileResponseFunding;
  fundingAmount: OrgProfileResponseFundingAmount;
  hqCountry: OrgProfileResponseHqCountry;
  id: number;
  industries: OrgProfileResponseIndustries;
  linkedin: OrgProfileResponseLinkedin;
  name: string;
  orgLogo: OrgProfileResponseOrgLogo;
  organizationSize: OrgProfileResponseOrganizationSize;
  organizationType: OrgProfileResponseOrganizationType;
  otherPartners: OrgProfileResponseOtherPartners;
  partners: OrgProfileResponsePartners;
  problem: OrgProfileResponseProblem;
  referralMethod: OrgProfileResponseReferralMethod;
  repCity: OrgProfileResponseRepCity;
  repCountry: OrgProfileResponseRepCountry;
  repJobTitle: OrgProfileResponseRepJobTitle;
  repLanguages: OrgProfileResponseRepLanguages;
  repLinkedin: OrgProfileResponseRepLinkedin;
  repProfilePicture: OrgProfileResponseRepProfilePicture;
  repTimezone: OrgProfileResponseRepTimezone;
  revenueAmount: OrgProfileResponseRevenueAmount;
  revenueGeneration: OrgProfileResponseRevenueGeneration;
  sdgTracking: OrgProfileResponseSdgTracking;
  sdgs: OrgProfileResponseSdgs;
  solution: OrgProfileResponseSolution;
  website: OrgProfileResponseWebsite;
  yearOfRegistration: OrgProfileResponseYearOfRegistration;
}

export type OrgProfileUpdateRequestBusinessModel = BusinessModel | null;

export type OrgProfileUpdateRequestBusinessModelDescription = string | null;

export type OrgProfileUpdateRequestCountries = number[] | null;

export type OrgProfileUpdateRequestExperienceHope = OrganizationExperienceHopeEnum[] | null;

export type OrgProfileUpdateRequestFunding = FundingStatus[] | null;

export type OrgProfileUpdateRequestFundingAmount = FundingAmount | null;

export type OrgProfileUpdateRequestImpactPartners = string[] | null;

export type OrgProfileUpdateRequestLinkedin = string | null;

export type OrgProfileUpdateRequestOrgLogo = string | null;

export type OrgProfileUpdateRequestOtherPartners = string | null;

export type OrgProfileUpdateRequestProblem = string | null;

export type OrgProfileUpdateRequestReferralMethod = string | null;

export type OrgProfileUpdateRequestRepLanguages = string[] | null;

export type OrgProfileUpdateRequestRepLinkedin = string | null;

export type OrgProfileUpdateRequestRepProfilePicture = string | null;

export type OrgProfileUpdateRequestRevenueAmount = RevenueAmount | null;

export type OrgProfileUpdateRequestRevenueGeneration = string | null;

export type OrgProfileUpdateRequestSdgTracking = string | null;

export type OrgProfileUpdateRequestSolution = string | null;

export interface OrgProfileUpdateRequest {
  businessModel: OrgProfileUpdateRequestBusinessModel;
  businessModelDescription: OrgProfileUpdateRequestBusinessModelDescription;
  countries: OrgProfileUpdateRequestCountries;
  experienceHope: OrgProfileUpdateRequestExperienceHope;
  funding: OrgProfileUpdateRequestFunding;
  fundingAmount: OrgProfileUpdateRequestFundingAmount;
  hqCountry: number;
  impactPartners: OrgProfileUpdateRequestImpactPartners;
  industries: string[];
  linkedin: OrgProfileUpdateRequestLinkedin;
  name: string;
  orgLogo: OrgProfileUpdateRequestOrgLogo;
  organizationSize: string;
  organizationType: string;
  otherPartners: OrgProfileUpdateRequestOtherPartners;
  problem: OrgProfileUpdateRequestProblem;
  referralMethod: OrgProfileUpdateRequestReferralMethod;
  repCity: string;
  repCountry: number;
  repJobTitle: string;
  repLanguages: OrgProfileUpdateRequestRepLanguages;
  repLinkedin: OrgProfileUpdateRequestRepLinkedin;
  repProfilePicture: OrgProfileUpdateRequestRepProfilePicture;
  repTimezone: string;
  revenueAmount: OrgProfileUpdateRequestRevenueAmount;
  revenueGeneration: OrgProfileUpdateRequestRevenueGeneration;
  sdgTracking: OrgProfileUpdateRequestSdgTracking;
  sdgs: string[];
  solution: OrgProfileUpdateRequestSolution;
  website: string;
  yearOfRegistration: number;
}

export type OrgRepOrgApplicationStatus = OrganizationApplicationStatusEnum | null;

export type OrgRepOrgAvatar = string | null;

export type OrgRepOrgCorporateClient = OrganizationPartner | null;

export interface OrgRepOrg {
  applicationStatus: OrgRepOrgApplicationStatus;
  avatar: OrgRepOrgAvatar;
  corporateClient: OrgRepOrgCorporateClient;
  id: number;
  name: string;
  partners: OrganizationPartner[];
}

export type OrgRepUserApplicationStatus = ProfessionalApplicationStatusEnum | null;

export type OrgRepUserAvatar = string | null;

export type OrgRepUserCohort = Cohort | null;

export type OrgRepUserCorporatePartner = string | null;

export type OrgRepUserCorporatePartnerLogo = string | null;

export type OrgRepUserLocation = Location | null;

export type OrgRepUserOrganization = OrgRepOrg | null;

export interface OrgRepUser {
  accountType: 'organization';
  applicationRoute: string;
  applicationStatus: OrgRepUserApplicationStatus;
  avatar: OrgRepUserAvatar;
  cohort: OrgRepUserCohort;
  corporatePartner: OrgRepUserCorporatePartner;
  corporatePartnerLogo: OrgRepUserCorporatePartnerLogo;
  firstName: string;
  lastName: string;
  location: OrgRepUserLocation;
  organization: OrgRepUserOrganization;
  role: string;
  tocAgreed: boolean;
  userId: number;
  userName: string;
}

export type OrganizationApplicationParametersBusinessModelDescription = string | null;

export type OrganizationApplicationParametersFundingAmount = FundingAmount | null;

export type OrganizationApplicationParametersImpactPartners = string[] | null;

export type OrganizationApplicationParametersLinkedin = string | null;

export type OrganizationApplicationParametersOtherPartners = string | null;

export type OrganizationApplicationParametersRepLanguages = string[] | null;

export type OrganizationApplicationParametersRepProfilePicture = string | null;

export type OrganizationApplicationParametersRevenueAmount = RevenueAmount | null;

export interface OrganizationApplicationParameters {
  businessModel: BusinessModel;
  businessModelDescription: OrganizationApplicationParametersBusinessModelDescription;
  countries: number[];
  experienceHope: OrganizationExperienceHopeEnum[];
  firstBusinessChallenge: BusinessChallengesEnum;
  firstBusinessChallengeDescription: string;
  funding: FundingStatus[];
  fundingAmount: OrganizationApplicationParametersFundingAmount;
  hqCountry: number;
  impactPartners: OrganizationApplicationParametersImpactPartners;
  industries: string[];
  linkedin: OrganizationApplicationParametersLinkedin;
  name: string;
  orgLogo: string;
  organizationSize: string;
  organizationType: string;
  otherPartners: OrganizationApplicationParametersOtherPartners;
  problem: string;
  referralMethod: string;
  repCity: string;
  repCountry: number;
  repJobTitle: string;
  repLanguages: OrganizationApplicationParametersRepLanguages;
  repLinkedin: string;
  repProfilePicture: OrganizationApplicationParametersRepProfilePicture;
  repTimezone: string;
  revenueAmount: OrganizationApplicationParametersRevenueAmount;
  revenueGeneration: string;
  sdgTracking: string;
  sdgs: string[];
  solution: string;
  website: string;
  yearOfRegistration: number;
}

export type OrganizationApplicationStatusEnum =
  (typeof OrganizationApplicationStatusEnum)[keyof typeof OrganizationApplicationStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationApplicationStatusEnum = {
  pending: 'pending',
  approved: 'approved',
  approved_match: 'approved_match',
  info_requested: 'info_requested',
  rejected: 'rejected',
  deactivated: 'deactivated',
} as const;

export type OrganizationApplicationStatusResponseApplicationStatus =
  OrganizationApplicationStatusEnum | null;

export interface OrganizationApplicationStatusResponse {
  applicationStatus: OrganizationApplicationStatusResponseApplicationStatus;
  applyCompleted: boolean;
}

export type OrganizationBusinessChallengesResponseChallengeId = number | null;

export interface OrganizationBusinessChallengesResponse {
  challengeId: OrganizationBusinessChallengesResponseChallengeId;
  challenges: BusinessChallenge[];
  organizationId: number;
}

export interface OrganizationDetailProject {
  createdAt: string;
  id: number;
  name: string;
  publishingStage: ProjectPublishingStage;
  representativeId: number;
  representativeName: string;
}

export interface OrganizationExistsResponse {
  exists: boolean;
}

export type OrganizationExperienceHopeEnum =
  (typeof OrganizationExperienceHopeEnum)[keyof typeof OrganizationExperienceHopeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationExperienceHopeEnum = {
  'increase-impact': 'increase-impact',
  'learn-grow-skills': 'learn-grow-skills',
  'increase-funding': 'increase-funding',
  'grow-network': 'grow-network',
  'grow-organization': 'grow-organization',
  other: 'other',
} as const;

export interface OrganizationInviteRequest {
  email: string;
  firstname: string;
  lastname: string;
  makeAdmin: boolean;
  removeRepresentative: boolean;
}

export interface OrganizationPartner {
  id: number;
  name: string;
}

export type OrganizationProfileResponseApplicationStatus = OrganizationApplicationStatusEnum | null;

export type OrganizationProfileResponseAvatarUrl = string | null;

export type OrganizationProfileResponseDateEstablished = string | null;

export type OrganizationProfileResponseLinkedinName = string | null;

export type OrganizationProfileResponseTeamSize = string | null;

export interface OrganizationProfileResponse {
  applicationStatus: OrganizationProfileResponseApplicationStatus;
  avatarUrl: OrganizationProfileResponseAvatarUrl;
  canProposeCustomProject: boolean;
  canViewJoinAlert: boolean;
  dateEstablished: OrganizationProfileResponseDateEstablished;
  industries: string[];
  leadRepId: number;
  linkedinName: OrganizationProfileResponseLinkedinName;
  locationCity: string;
  locationCountry: string;
  orgName: string;
  organizationType: string;
  partners: OrgProfilePartnerResponse[];
  problemStatement: string;
  projects: OrgProfileProjectResponse[];
  reps: DirectoryOrgRepInfo[];
  solutionDescription: string;
  sustainabilityGoals: string[];
  teamSize: OrganizationProfileResponseTeamSize;
  websiteUrl: string;
}

export type OrganizationSearchCardBusinessType = string | null;

export type OrganizationSearchCardCountryCode = string | null;

export type OrganizationSearchCardImage = string | null;

export type OrganizationSearchCardIndustries = string[] | null;

export type OrganizationSearchCardLocation = string | null;

export interface OrganizationSearchCard {
  businessType: OrganizationSearchCardBusinessType;
  causes: string[];
  countryCode: OrganizationSearchCardCountryCode;
  id: number;
  image: OrganizationSearchCardImage;
  industries: OrganizationSearchCardIndustries;
  location: OrganizationSearchCardLocation;
  name: string;
  publishedUnassignedProjectCount: number;
}

export interface OrganizationSearchResponse {
  filteredCount: number;
  organizations: OrganizationSearchCard[];
}

export type OrganizationSizeResponseName = string | null;

export interface OrganizationSizeResponse {
  id: number;
  name: OrganizationSizeResponseName;
}

export interface OrganizationSubmissionResponse {
  status: OrganizationApplicationStatusEnum;
}

export type OrganizationTypeResponseName = string | null;

export interface OrganizationTypeResponse {
  id: number;
  name: OrganizationTypeResponseName;
}

export type PartnerDetailsLinkedinUrl = string | null;

export type PartnerDetailsLogo = string | null;

export type PartnerDetailsUrlParameter = string | null;

export interface PartnerDetails {
  active: boolean;
  description: string;
  link: string;
  linkedinUrl: PartnerDetailsLinkedinUrl;
  logo: PartnerDetailsLogo;
  name: string;
  urlParameter: PartnerDetailsUrlParameter;
}

export type PartnerIdByParamResponsePartnerId = number | null;

export interface PartnerIdByParamResponse {
  partnerId: PartnerIdByParamResponsePartnerId;
}

export interface PartnerResponse {
  id: number;
  name: string;
}

export type PendingApplicantDataApplicationDate = string | null;

export type PendingApplicantDataApplicationStatus = ProfessionalApplicationStatusEnum | null;

export interface PendingApplicantData {
  applicationDate: PendingApplicantDataApplicationDate;
  applicationStatus: PendingApplicantDataApplicationStatus;
  email: string;
  id: number;
  name: string;
}

export type PlanContactCardAvatar = string | null;

export interface PlanContactCard {
  avatar: PlanContactCardAvatar;
  email: string;
  firstname: string;
  id: number;
  lastname: string;
}

export interface PlanDeliverable {
  context: string;
  deliverable: string;
  id: number;
}

export interface PlanOrgBrief {
  constraints: string;
  id: number;
  impact: string;
  objective: string;
  obstacle: string;
  primaryOutcome: string;
  questions: string;
  stepsTaken: string;
  updatedAt: string;
}

export interface PlanProBrief {
  id: number;
  questions: string;
  updatedAt: string;
}

export interface PlanSkillAlignment {
  id: number;
  skillsAlignment: string;
  userFirstname: string;
  userId: number;
  userLastname: string;
}

export interface PlanTasks {
  id: number;
  task: string;
  userFirstname: string;
  userId: number;
  userLastname: string;
}

export type PlanUpdateRequestNotes = string | null;

export interface PlanUpdateRequest {
  isTeam: boolean;
  notes: PlanUpdateRequestNotes;
  outcome: PlanningUpdateOutcomeEnum;
  projectId: number;
}

export type PlanningUpdateOutcomeEnum =
  (typeof PlanningUpdateOutcomeEnum)[keyof typeof PlanningUpdateOutcomeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanningUpdateOutcomeEnum = {
  complete: 'complete',
  unresponsive: 'unresponsive',
  in_progress: 'in_progress',
  need_help: 'need_help',
} as const;

export interface PostMatchNewProjectThirtyDaysRepPayload {
  assignment_id: number;
  email_type?: 'POST_MATCH_NEW_PROJECT_THIRTY_DAYS_REP';
}

export interface PostMatchSurveyFourteenDaysProPayload {
  assignment_id: number;
  email_type?: 'POST_MATCH_SURVEY_FOURTEEN_DAYS_PRO';
}

export interface PostMatchSurveyFourteenDaysRepPayload {
  assignment_id: number;
  email_type?: 'POST_MATCH_SURVEY_FOURTEEN_DAYS_REP';
}

export interface PostMatchSurveyOneDayProPayload {
  assignment_id: number;
  email_type?: 'POST_MATCH_SURVEY_ONE_DAY_PRO';
}

export interface PostMatchSurveyOneDayRepPayload {
  assignment_id: number;
  email_type?: 'POST_MATCH_SURVEY_ONE_DAY_REP';
}

export type ProCardAssignmentCreatedAt = string | null;

export type ProCardAssignmentDiscoveryId = number | null;

export type ProCardAvatar = string | null;

export type ProCardProject = MyProjectsProject | null;

export type ProCardRepTimezone = string | null;

export interface ProCard {
  assignmentCreatedAt: ProCardAssignmentCreatedAt;
  assignmentDiscoveryId: ProCardAssignmentDiscoveryId;
  avatar: ProCardAvatar;
  cardStatus: CardStatusEnum;
  cardStatusChangedAt: string;
  completed: boolean;
  introduction: MyProjectsIntroduction;
  isCustom: boolean;
  organization: MyProjectsOrganization;
  project: ProCardProject;
  repTimezone: ProCardRepTimezone;
}

export interface ProMyProjectsResponse {
  actionRequired: ProCard[];
  inProgress: ProCard[];
  inactive: ProCard[];
  saved: ProSavedProjectCard[];
  teamCards: ProTeamCard[];
}

export interface ProOnboardOneDayPayload {
  email_type?: 'PRO_ONBOARD_ONE_DAY';
  pro_user_id: number;
}

export interface ProOnboardTwoDaysPayload {
  email_type?: 'PRO_ONBOARD_TWO_DAYS';
  pro_user_id: number;
}

export type ProSavedProjectCardAvatar = string | null;

export interface ProSavedProjectCard {
  avatar: ProSavedProjectCardAvatar;
  cardStatus: 'saved';
  organization: MyProjectsOrganization;
  project: MyProjectsProject;
  savedAt: string;
}

export type ProTeamCardAvatar = string | null;

export interface ProTeamCard {
  avatar: ProTeamCardAvatar;
  cardStatus: CardStatusEnum;
  cardStatusChangedAt: string;
  organization: MyProjectsOrganization;
  project: MyProjectsProject;
}

export interface ProUserExportPreviewResponse {
  filteredCount: number;
  users: ProfessionalExportData[];
}

export interface ProUserExportResponse {
  users: ProfessionalExportData[];
}

export type ProfessionalApplicationDataBoardArea = BoardAreaEnum | null;

export type ProfessionalApplicationDataBusinessUnit = string | null;

export type ProfessionalApplicationDataCity = string | null;

export type ProfessionalApplicationDataCountry = number | null;

export type ProfessionalApplicationDataCurrentEmployer = string | null;

export type ProfessionalApplicationDataDepartment = DepartmentEnum | null;

export type ProfessionalApplicationDataExperienceHope = string[] | null;

export type ProfessionalApplicationDataExperienceHopeOther = string | null;

export type ProfessionalApplicationDataHasWorkedAtSap = boolean | null;

export type ProfessionalApplicationDataJobFunction = string | null;

export type ProfessionalApplicationDataJobTitle = string | null;

export type ProfessionalApplicationDataLinkedin = string | null;

export type ProfessionalApplicationDataPreviousVolunteerExperience = string | null;

export type ProfessionalApplicationDataProfilePicture = string | null;

export type ProfessionalApplicationDataReferralMethod = string | null;

export type ProfessionalApplicationDataRepeatVolunteer = string | null;

export type ProfessionalApplicationDataResume = string | null;

export type ProfessionalApplicationDataSkillsImpact = string | null;

export type ProfessionalApplicationDataTheatre = TheatreEnum | null;

export type ProfessionalApplicationDataTimezone = string | null;

export type ProfessionalApplicationDataWorkType = WorkTypeEnum | null;

export type ProfessionalApplicationDataYearsOfExperience = number | null;

/**
 * All possible pro data points, supports re-populating the application form for existing user
 */
export interface ProfessionalApplicationData {
  boardArea: ProfessionalApplicationDataBoardArea;
  businessUnit: ProfessionalApplicationDataBusinessUnit;
  city: ProfessionalApplicationDataCity;
  country: ProfessionalApplicationDataCountry;
  currentEmployer: ProfessionalApplicationDataCurrentEmployer;
  department: ProfessionalApplicationDataDepartment;
  experienceHope: ProfessionalApplicationDataExperienceHope;
  experienceHopeOther: ProfessionalApplicationDataExperienceHopeOther;
  hasWorkedAtSap: ProfessionalApplicationDataHasWorkedAtSap;
  impactAreas: string[];
  industries: string[];
  jobFunction: ProfessionalApplicationDataJobFunction;
  jobTitle: ProfessionalApplicationDataJobTitle;
  languages: string[];
  linkedin: ProfessionalApplicationDataLinkedin;
  previousVolunteerExperience: ProfessionalApplicationDataPreviousVolunteerExperience;
  profilePicture: ProfessionalApplicationDataProfilePicture;
  referralMethod: ProfessionalApplicationDataReferralMethod;
  repeatVolunteer: ProfessionalApplicationDataRepeatVolunteer;
  resume: ProfessionalApplicationDataResume;
  skills: SkillsExperience[];
  skillsImpact: ProfessionalApplicationDataSkillsImpact;
  theatre: ProfessionalApplicationDataTheatre;
  timezone: ProfessionalApplicationDataTimezone;
  workType: ProfessionalApplicationDataWorkType;
  yearsOfExperience: ProfessionalApplicationDataYearsOfExperience;
}

export type ProfessionalApplicationParametersCohortId = number | null;

export type ProfessionalApplicationParametersExperienceHopeOther = string | null;

export type ProfessionalApplicationParametersLinkedin = string | null;

export type ProfessionalApplicationParametersProfilePicture = string | null;

export type ProfessionalApplicationParametersResume = string | null;

export interface ProfessionalApplicationParameters {
  city: string;
  cohortId: ProfessionalApplicationParametersCohortId;
  country: number;
  experienceHope: ProfessionalExperienceHopeEnum[];
  experienceHopeOther: ProfessionalApplicationParametersExperienceHopeOther;
  impactAreas: string[];
  industries: string[];
  jobTitle: string;
  languages: string[];
  linkedin: ProfessionalApplicationParametersLinkedin;
  profilePicture: ProfessionalApplicationParametersProfilePicture;
  referralMethod: string;
  resume: ProfessionalApplicationParametersResume;
  skills: SkillsExperience[];
  skillsImpact: string;
  timezone: string;
  yearsOfExperience: number;
}

export type ProfessionalApplicationStatusEnum =
  (typeof ProfessionalApplicationStatusEnum)[keyof typeof ProfessionalApplicationStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProfessionalApplicationStatusEnum = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  waitlisted: 'waitlisted',
} as const;

export type ProfessionalApplicationStatusResponseApplicationStatus =
  ProfessionalApplicationStatusEnum | null;

export type ProfessionalApplicationStatusResponseClientUrlParam = string | null;

export type ProfessionalApplicationStatusResponseCohortId = number | null;

export type ProfessionalApplicationStatusResponseCohortKickoffDate = string | null;

export type ProfessionalApplicationStatusResponsePartnerId = number | null;

export interface ProfessionalApplicationStatusResponse {
  applicationStatus: ProfessionalApplicationStatusResponseApplicationStatus;
  applyCompleted: boolean;
  clientUrlParam: ProfessionalApplicationStatusResponseClientUrlParam;
  cohortId: ProfessionalApplicationStatusResponseCohortId;
  cohortKickoffDate: ProfessionalApplicationStatusResponseCohortKickoffDate;
  partnerId: ProfessionalApplicationStatusResponsePartnerId;
}

export type ProfessionalExperienceHopeEnum =
  (typeof ProfessionalExperienceHopeEnum)[keyof typeof ProfessionalExperienceHopeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProfessionalExperienceHopeEnum = {
  'learn-social-impact': 'learn-social-impact',
  'use-improve-skills': 'use-improve-skills',
  networking: 'networking',
  'help-community': 'help-community',
  leadership: 'leadership',
  other: 'other',
} as const;

export type ProfessionalExportDataApplicationStatus = string | null;

export type ProfessionalExportDataCauses = string | null;

export type ProfessionalExportDataCohort = string | null;

export type ProfessionalExportDataContinent = string | null;

export type ProfessionalExportDataCorporateClient = string | null;

export type ProfessionalExportDataCountry = string | null;

export type ProfessionalExportDataExperienceYears = number | null;

export type ProfessionalExportDataFirstName = string | null;

export type ProfessionalExportDataHeadline = string | null;

export type ProfessionalExportDataLanguages = string | null;

export type ProfessionalExportDataLastName = string | null;

export type ProfessionalExportDataPositionTitle = string | null;

export type ProfessionalExportDataSkills = string | null;

export type ProfessionalExportDataSkillsExplanation = string | null;

export type ProfessionalExportDataTimezone = string | null;

export interface ProfessionalExportData {
  applicationStatus: ProfessionalExportDataApplicationStatus;
  causes: ProfessionalExportDataCauses;
  cohort: ProfessionalExportDataCohort;
  continent: ProfessionalExportDataContinent;
  corporateClient: ProfessionalExportDataCorporateClient;
  country: ProfessionalExportDataCountry;
  email: string;
  experienceYears: ProfessionalExportDataExperienceYears;
  firstName: ProfessionalExportDataFirstName;
  headline: ProfessionalExportDataHeadline;
  id: number;
  languages: ProfessionalExportDataLanguages;
  lastName: ProfessionalExportDataLastName;
  positionTitle: ProfessionalExportDataPositionTitle;
  skills: ProfessionalExportDataSkills;
  skillsExplanation: ProfessionalExportDataSkillsExplanation;
  timezone: ProfessionalExportDataTimezone;
}

export type ProfessionalInterestSurveySubmissionCity = string | null;

export type ProfessionalInterestSurveySubmissionCountryId = number | null;

export type ProfessionalInterestSurveySubmissionCurrentEmployer = string | null;

export type ProfessionalInterestSurveySubmissionJobTitle = string | null;

export type ProfessionalInterestSurveySubmissionOutcomeReason = string | null;

export type ProfessionalInterestSurveySubmissionTriggerOther = string | null;

export interface ProfessionalInterestSurveySubmission {
  city: ProfessionalInterestSurveySubmissionCity;
  countryId: ProfessionalInterestSurveySubmissionCountryId;
  coverage: SurveyCoverageEnum;
  currentEmployer: ProfessionalInterestSurveySubmissionCurrentEmployer;
  email: string;
  investment: SurveyInvestmentEnum;
  jobTitle: ProfessionalInterestSurveySubmissionJobTitle;
  newsletterOptIn: boolean;
  outcome: SurveyOutcomeEnum;
  outcomeReason: ProfessionalInterestSurveySubmissionOutcomeReason;
  trigger: SurveyTriggerEnum;
  triggerOther: ProfessionalInterestSurveySubmissionTriggerOther;
}

export type ProfessionalProfileResponseAvatar = string | null;

export type ProfessionalProfileResponseCohort = Cohort | null;

export type ProfessionalProfileResponseEmployer = string | null;

export type ProfessionalProfileResponseExperienceYears = number | null;

export type ProfessionalProfileResponseHeadline = string | null;

export type ProfessionalProfileResponseIdealProjects = string | null;

export type ProfessionalProfileResponseIntroCtaState =
  | CanSendIntroCTAState
  | CanSendIntroReceivedIntroCTAState
  | CanSendIntroSentIntroCTAState
  | HiddenIntroCTAState
  | OneProjectIntroReceivedIntroCTAState
  | OneProjectIntroSentIntroCTAState
  | MatchedIntroCTAState;

export type ProfessionalProfileResponseLocation = Location | null;

export type ProfessionalProfileResponsePositionTitle = string | null;

export type ProfessionalProfileResponseResume = string | null;

export interface ProfessionalProfileResponse {
  avatar: ProfessionalProfileResponseAvatar;
  canSendIntro: boolean;
  cohort: ProfessionalProfileResponseCohort;
  currentUserIsAuthed: boolean;
  employer: ProfessionalProfileResponseEmployer;
  experienceYears: ProfessionalProfileResponseExperienceYears;
  firstName: string;
  fluentLanguages: string[];
  headline: ProfessionalProfileResponseHeadline;
  idealProjects: ProfessionalProfileResponseIdealProjects;
  industries: string[];
  introCtaState: ProfessionalProfileResponseIntroCtaState;
  lastName: string;
  location: ProfessionalProfileResponseLocation;
  otherLanguages: string[];
  positionTitle: ProfessionalProfileResponsePositionTitle;
  preferredCauses: string[];
  preferredLocations: string[];
  resume: ProfessionalProfileResponseResume;
  role: string;
  searchStatus: SearchStatusEnum;
  skills: string[];
  socialMedia: SocialMediaMap;
}

export interface ProfessionalSubmissionResponse {
  status: ProfessionalApplicationStatusEnum;
}

export type ProfessionalType = (typeof ProfessionalType)[keyof typeof ProfessionalType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProfessionalType = {
  ey: 'ey',
  f5: 'f5',
  generic: 'generic',
  kering: 'kering',
  mwi: 'mwi',
  paypal: 'paypal',
  reckitt: 'reckitt',
  sap: 'sap',
  tsh: 'tsh',
  wmp: 'wmp',
  lumen: 'lumen',
  philips: 'philips',
} as const;

export type ProfessionalUserApplicationStatus = ProfessionalApplicationStatusEnum | null;

export type ProfessionalUserAvatar = string | null;

export type ProfessionalUserCohort = Cohort | null;

export type ProfessionalUserCorporatePartner = string | null;

export type ProfessionalUserCorporatePartnerLogo = string | null;

export type ProfessionalUserLocation = Location | null;

export type ProfessionalUserSearchStatus = SearchStatusEnum | null;

export interface ProfessionalUser {
  accountType: 'experteer';
  applicationRoute: string;
  applicationStatus: ProfessionalUserApplicationStatus;
  avatar: ProfessionalUserAvatar;
  cohort: ProfessionalUserCohort;
  corporatePartner: ProfessionalUserCorporatePartner;
  corporatePartnerLogo: ProfessionalUserCorporatePartnerLogo;
  firstName: string;
  lastName: string;
  location: ProfessionalUserLocation;
  professionalType: ProfessionalType;
  role: string;
  searchStatus: ProfessionalUserSearchStatus;
  tocAgreed: boolean;
  userId: number;
  userName: string;
}

export type ProfileResponseCity = string | null;

export type ProfileResponseCountry = number | null;

export type ProfileResponseJobTitle = string | null;

export type ProfileResponseLinkedin = string | null;

export type ProfileResponseProfilePicture = string | null;

export type ProfileResponseResume = string | null;

export type ProfileResponseTimezone = string | null;

export type ProfileResponseYearsOfExperience = number | null;

export interface ProfileResponse {
  city: ProfileResponseCity;
  country: ProfileResponseCountry;
  industries: string[];
  jobTitle: ProfileResponseJobTitle;
  languages: string[];
  linkedin: ProfileResponseLinkedin;
  profilePicture: ProfileResponseProfilePicture;
  resume: ProfileResponseResume;
  skills: SkillsExperience[];
  timezone: ProfileResponseTimezone;
  yearsOfExperience: ProfileResponseYearsOfExperience;
}

/**
 * Enum representing different possible states of a project hub accordion section, ie introduction, discovery, plan, etc
 */
export type ProgressStepStatusEnum =
  (typeof ProgressStepStatusEnum)[keyof typeof ProgressStepStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProgressStepStatusEnum = {
  active_in_progress: 'active_in_progress',
  inactive_in_progress: 'inactive_in_progress',
  not_started: 'not_started',
  success: 'success',
  failure: 'failure',
} as const;

export interface ProjectActionIncompleteMinusSevenDaysPayload {
  assignment_id: number;
  email_type?: 'ACTION_INCOMPLETE_MINUS_SEVEN_DAYS';
  user_id: number;
}

export interface ProjectActionIncompletePayload {
  assignment_id: number;
  email_type?: 'ACTION_INCOMPLETE';
  user_id: number;
}

export interface ProjectActionIncompletePlusSevenDaysPayload {
  assignment_id: number;
  email_type?: 'ACTION_INCOMPLETE_PLUS_SEVEN_DAYS';
  user_id: number;
}

export interface ProjectAvailableForIntro {
  projectId: number;
  projectName: string;
}

export type ProjectHubResponseAction = HubActionData | null;

export type ProjectHubResponsePlanningGuideUrl = string | null;

export type ProjectHubResponseProject = HubProject | null;

export type ProjectHubResponseProjectPlanId = number | null;

export type ProjectHubResponseStoryUrl = string | null;

export type ProjectHubResponseSurveyUrl = string | null;

export interface ProjectHubResponse {
  action: ProjectHubResponseAction;
  discovery: HubDiscovery;
  displayPlanUi: boolean;
  introduction: HubIntroduction;
  organization: HubOrganization;
  planningGuideUrl: ProjectHubResponsePlanningGuideUrl;
  professional: HubContactCard;
  progress: HubProgressResponse;
  project: ProjectHubResponseProject;
  projectPlanId: ProjectHubResponseProjectPlanId;
  representative: HubContactCard;
  status: HubStatusEnum;
  storyUrl: ProjectHubResponseStoryUrl;
  surveyUrl: ProjectHubResponseSurveyUrl;
  userType: SimplifiedUserRole;
}

export type ProjectPlanDataAssignmentDiscoveryId = number | null;

export type ProjectPlanDataAvailabilityNotes = string | null;

export type ProjectPlanDataBeforeUpdatedAt = string | null;

export type ProjectPlanDataCommunicationNotes = string | null;

export type ProjectPlanDataCurrentUserId = number | null;

export type ProjectPlanDataEndDate = string | null;

export type ProjectPlanDataNextSteps = string | null;

export type ProjectPlanDataOrganizationBrief = PlanOrgBrief | null;

export type ProjectPlanDataProBrief = PlanProBrief | null;

export type ProjectPlanDataProfessional = PlanContactCard | null;

export type ProjectPlanDataProjectDescription = string | null;

export type ProjectPlanDataProjectId = number | null;

export type ProjectPlanDataStartDate = string | null;

export type ProjectPlanDataTimeCommitment = string | null;

export type ProjectPlanDataUpdatedAt = string | null;

export interface ProjectPlanData {
  assignmentDiscoveryId: ProjectPlanDataAssignmentDiscoveryId;
  availabilityNotes: ProjectPlanDataAvailabilityNotes;
  beforeUpdatedAt: ProjectPlanDataBeforeUpdatedAt;
  communicationNotes: ProjectPlanDataCommunicationNotes;
  currentUserId: ProjectPlanDataCurrentUserId;
  deliverables: PlanDeliverable[];
  endDate: ProjectPlanDataEndDate;
  id: number;
  isTeam: boolean;
  nextSteps: ProjectPlanDataNextSteps;
  organizationBrief: ProjectPlanDataOrganizationBrief;
  organizationName: string;
  proBrief: ProjectPlanDataProBrief;
  professional: ProjectPlanDataProfessional;
  projectDescription: ProjectPlanDataProjectDescription;
  projectId: ProjectPlanDataProjectId;
  representative: PlanContactCard;
  skillAlignments: PlanSkillAlignment[];
  startDate: ProjectPlanDataStartDate;
  tasks: PlanTasks[];
  teamMembers: PlanContactCard[];
  timeCommitment: ProjectPlanDataTimeCommitment;
  updatedAt: ProjectPlanDataUpdatedAt;
  userRole: string;
}

export interface ProjectPlanIncompleteFifteenDaysPayload {
  assignment_id: number;
  email_type?: 'PLAN_INCOMPLETE_REMINDER_FIFTEEN_DAYS';
  user_id: number;
}

export interface ProjectPlanIncompleteFifteenDaysPayloadV2 {
  assignment_id: number;
  email_type?: 'PLAN_INCOMPLETE_REMINDER_FIFTEEN_DAYS_V2';
  user_id: number;
}

export interface ProjectPlanIncompleteTenDaysPayload {
  assignment_id: number;
  email_type?: 'PLAN_INCOMPLETE_REMINDER_TEN_DAYS';
  user_id: number;
}

export interface ProjectPlanIncompleteTenDaysPayloadV2 {
  assignment_id: number;
  email_type?: 'PLAN_INCOMPLETE_REMINDER_TEN_DAYS_V2';
  user_id: number;
}

export type ProjectProfileResponseDeliverables = string[] | null;

export type ProjectProfileResponseIntroCtaState =
  | CanSendIntroCTAState
  | CanSendIntroReceivedIntroCTAState
  | CanSendIntroSentIntroCTAState
  | HiddenIntroCTAState
  | OneProjectIntroReceivedIntroCTAState
  | OneProjectIntroSentIntroCTAState
  | MatchedIntroCTAState;

export type ProjectProfileResponseRepMatchedDate = string | null;

export type ProjectProfileResponseWhatYouWillLearnDescription = string | null;

export interface ProjectProfileResponse {
  backgroundDescription: string;
  deliverables: ProjectProfileResponseDeliverables;
  expertises: string[];
  introCtaState: ProjectProfileResponseIntroCtaState;
  isSaved: boolean;
  leadRepId: number;
  name: string;
  orgDetails: DirectoryBaseOrgInfo;
  orgId: number;
  orgReps: DirectoryOrgRepInfo[];
  projectRoleType: ProjectRoleType;
  repMatchedDate: ProjectProfileResponseRepMatchedDate;
  userCanEdit: boolean;
  userCanSave: boolean;
  userCanViewJoinAlert: boolean;
  userIsAuthed: boolean;
  whatYouMightDoDescription: string;
  whatYouWillLearnDescription: ProjectProfileResponseWhatYouWillLearnDescription;
}

export type ProjectPublishingStage =
  (typeof ProjectPublishingStage)[keyof typeof ProjectPublishingStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectPublishingStage = {
  draft: 'draft',
  review: 'review',
  revision_requested: 'revision_requested',
  published: 'published',
  unpublished: 'unpublished',
} as const;

/**
 * Error response model for project recommendations
 */
export interface ProjectRecommendationErrorResponse {
  detail: string;
}

/**
 * Request model for project recommendations
 */
export interface ProjectRecommendationRequest {
  professionalId: number;
  projectId: number;
}

/**
 * Response model for project recommendations
 */
export interface ProjectRecommendationSuccessResponse {
  professionalName: string;
}

export type ProjectRoleType = (typeof ProjectRoleType)[keyof typeof ProjectRoleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectRoleType = {
  call: 'call',
  coach: 'coach',
  trainer: 'trainer',
  mentor: 'mentor',
  consultant: 'consultant',
} as const;

export type ProjectSearchCardCountryCode = string | null;

export type ProjectSearchCardImage = string | null;

export interface ProjectSearchCard {
  countryCode: ProjectSearchCardCountryCode;
  expertises: string[];
  id: number;
  image: ProjectSearchCardImage;
  location: string;
  name: string;
  organizationName: string;
  roleType: ProjectRoleType;
}

export interface ProjectSearchResponse {
  filteredCount: number;
  projects: ProjectSearchCard[];
}

export interface ProjectSearchResultPreviewResponse {
  filteredCount: number;
  projects: SearchProject[];
}

export type ProjectStage = (typeof ProjectStage)[keyof typeof ProjectStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectStage = {
  unassigned: 'unassigned',
  assigned: 'assigned',
  prep: 'prep',
  active: 'active',
  complete: 'complete',
  withdrawn: 'withdrawn',
} as const;

export type ProjectSuggestionProjectId = number | null;

export type ProjectSuggestionSuggestedDate = SuggestionDate | null;

export interface ProjectSuggestion {
  background: string;
  businessChallenge: string;
  challengeContext: string;
  deliverables: string[];
  focus: string;
  id: number;
  learningOutcomes: string;
  projectId: ProjectSuggestionProjectId;
  skills: string[];
  suggestedDate: ProjectSuggestionSuggestedDate;
  title: string;
}

export interface ProjectSuggestionResponse {
  projectSuggestions: ProjectSuggestion[];
}

export interface ProjectSummary {
  id: number;
  name: string;
  organizationId: number;
  organizationName: string;
}

export type ProjectSummaryResponseProjectSummary = ProjectSummary | null;

export interface ProjectSummaryResponse {
  projectSummary: ProjectSummaryResponseProjectSummary;
}

export interface ProposeTeamsRequest {
  cohort_id: number;
}

/**
 * A short admin-authored note about a participant's progress, shown as 'Recent updates' on the
corporate client dashboard. Editable by platform admins only; read-only for corporate clients.
 */
export interface RecentUpdateData {
  text: string;
  updatedAt: string;
}

export type RecentUpdateRequestNotes = string | null;

export interface RecentUpdateRequest {
  notes: RecentUpdateRequestNotes;
}

export type ReckittApplicationParametersCohortId = number | null;

export type ReckittApplicationParametersExperienceHopeOther = string | null;

export type ReckittApplicationParametersLinkedin = string | null;

export type ReckittApplicationParametersPreviousVolunteerExperience = string | null;

export type ReckittApplicationParametersProfilePicture = string | null;

export type ReckittApplicationParametersResume = string | null;

export interface ReckittApplicationParameters {
  businessUnit: string;
  city: string;
  cohortId: ReckittApplicationParametersCohortId;
  country: number;
  experienceHope: ProfessionalExperienceHopeEnum[];
  experienceHopeOther: ReckittApplicationParametersExperienceHopeOther;
  impactAreas: string[];
  industries: string[];
  jobFunction: string;
  jobTitle: string;
  languages: string[];
  linkedin: ReckittApplicationParametersLinkedin;
  previousVolunteerExperience: ReckittApplicationParametersPreviousVolunteerExperience;
  profilePicture: ReckittApplicationParametersProfilePicture;
  referralMethod: string;
  repeatVolunteer: string;
  resume: ReckittApplicationParametersResume;
  skills: SkillsExperience[];
  skillsImpact: string;
  timezone: string;
  yearsOfExperience: number;
}

export interface RefreshMeetingsRequest {
  fromDate: string;
  toDate: string;
}

export interface RejectedApplicantData {
  email: string;
  id: number;
  name: string;
  rejectedDate: string;
}

export type RepCardAssignmentCreatedAt = string | null;

export type RepCardAssignmentDiscoveryId = number | null;

export type RepCardAvatar = string | null;

export type RepCardRepTimezone = string | null;

export interface RepCard {
  assignmentCreatedAt: RepCardAssignmentCreatedAt;
  assignmentDiscoveryId: RepCardAssignmentDiscoveryId;
  avatar: RepCardAvatar;
  cardStatus: CardStatusEnum;
  cardStatusChangedAt: string;
  introduction: MyProjectsIntroduction;
  professional: MyProjectsProfessional;
  repTimezone: RepCardRepTimezone;
}

export interface RepMyProjectsResponse {
  active: RepProjectPanel[];
  inactive: RepProjectPanel[];
  underReview: RepProjectPanel[];
}

export type RepProjectPanelProject = MyProjectsProject | null;

export interface RepProjectPanel {
  actionRequired: RepCard[];
  completed: boolean;
  inProgress: RepCard[];
  inactive: RepCard[];
  isCustom: boolean;
  project: RepProjectPanelProject;
  teamCards: RepTeamCard[];
}

export interface RepTeamCard {
  cardStatus: CardStatusEnum;
  cardStatusChangedAt: string;
  project: MyProjectsProject;
}

export interface RepUserExportPreviewResponse {
  filteredCount: number;
  users: RepresentativeExportData[];
}

export interface RepUserExportResponse {
  users: RepresentativeExportData[];
}

export type RepresentativeExportDataBusinessChallenges = string | null;

export type RepresentativeExportDataContinent = string | null;

export type RepresentativeExportDataCorporateClient = string | null;

export type RepresentativeExportDataCountry = string | null;

export type RepresentativeExportDataFirstName = string | null;

export type RepresentativeExportDataImpactPartners = string | null;

export type RepresentativeExportDataLastName = string | null;

export type RepresentativeExportDataOrganizationApplicationStatus = string | null;

export type RepresentativeExportDataOrganizationId = number | null;

export type RepresentativeExportDataOrganizationIndustries = string | null;

export type RepresentativeExportDataOrganizationName = string | null;

export type RepresentativeExportDataTimezone = string | null;

export interface RepresentativeExportData {
  businessChallenges: RepresentativeExportDataBusinessChallenges;
  continent: RepresentativeExportDataContinent;
  corporateClient: RepresentativeExportDataCorporateClient;
  country: RepresentativeExportDataCountry;
  email: string;
  firstName: RepresentativeExportDataFirstName;
  id: number;
  impactPartners: RepresentativeExportDataImpactPartners;
  lastName: RepresentativeExportDataLastName;
  organizationApplicationStatus: RepresentativeExportDataOrganizationApplicationStatus;
  organizationId: RepresentativeExportDataOrganizationId;
  organizationIndustries: RepresentativeExportDataOrganizationIndustries;
  organizationName: RepresentativeExportDataOrganizationName;
  timezone: RepresentativeExportDataTimezone;
}

export interface RequestPasswordResetParameters {
  email: string;
}

export interface RequestReviewRequest {
  projectId: number;
}

export interface ResendResetEmailParameters {
  email: string;
}

export interface ResendVerificationEmailParameters {
  email: string;
}

export interface ResetUserRequest {
  newUserType: AccountTypeEnum;
  userId: number;
}

export type RevenueAmount = (typeof RevenueAmount)[keyof typeof RevenueAmount];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RevenueAmount = {
  '1,000_-_10,000': '1,000 - 10,000',
  '10,000_-_50,000': '10,000 - 50,000',
  '50,000_-_100,000': '50,000 - 100,000',
  '100,000_-_250,000': '100,000 - 250,000',
  '250,000_-_500,000': '250,000 - 500,000',
  '500,000_-_1,000,000': '500,000 - 1,000,000',
  '1,000,000_-_2,500,000': '1,000,000 - 2,500,000',
  '2,500,000+': '2,500,000+',
} as const;

export type ReviewOrgDataApplicationId = number | null;

export type ReviewOrgDataApplicationStatus = OrganizationApplicationStatusEnum | null;

export type ReviewOrgDataApplicationUpdated = string | null;

export type ReviewOrgDataBusinessProblem = string | null;

export type ReviewOrgDataBusinessSolution = string | null;

export type ReviewOrgDataChallengeOne = string | null;

export type ReviewOrgDataChallengeThree = string | null;

export type ReviewOrgDataChallengeTwo = string | null;

export type ReviewOrgDataContextOne = string | null;

export type ReviewOrgDataContextThree = string | null;

export type ReviewOrgDataContextTwo = string | null;

export type ReviewOrgDataCorporateClient = string | null;

export type ReviewOrgDataCountries = string[] | null;

export type ReviewOrgDataDescription = string | null;

export type ReviewOrgDataGeneratingRevenue = boolean | null;

export type ReviewOrgDataHqCountryId = number | null;

export type ReviewOrgDataImpactStory = string | null;

export type ReviewOrgDataImpactTracking = string | null;

export type ReviewOrgDataLinkedin = string | null;

export type ReviewOrgDataOrganizationSizeId = number | null;

export type ReviewOrgDataOrganizationTypeId = number | null;

export type ReviewOrgDataRegistrationDate = number | null;

export type ReviewOrgDataRevenueAmount = string | null;

export type ReviewOrgDataType = string | null;

export type ReviewOrgDataWebsite = string | null;

export interface ReviewOrgData {
  applicationId: ReviewOrgDataApplicationId;
  applicationStatus: ReviewOrgDataApplicationStatus;
  applicationUpdated: ReviewOrgDataApplicationUpdated;
  businessProblem: ReviewOrgDataBusinessProblem;
  businessSolution: ReviewOrgDataBusinessSolution;
  causes: string[];
  challengeOne: ReviewOrgDataChallengeOne;
  challengeThree: ReviewOrgDataChallengeThree;
  challengeTwo: ReviewOrgDataChallengeTwo;
  city: string;
  contextOne: ReviewOrgDataContextOne;
  contextThree: ReviewOrgDataContextThree;
  contextTwo: ReviewOrgDataContextTwo;
  corporateClient: ReviewOrgDataCorporateClient;
  countries: ReviewOrgDataCountries;
  country: string;
  createdAt: string;
  description: ReviewOrgDataDescription;
  generatingRevenue: ReviewOrgDataGeneratingRevenue;
  hqCountryId: ReviewOrgDataHqCountryId;
  impactStory: ReviewOrgDataImpactStory;
  impactTracking: ReviewOrgDataImpactTracking;
  industries: string[];
  linkedin: ReviewOrgDataLinkedin;
  name: string;
  organizationId: number;
  organizationSizeId: ReviewOrgDataOrganizationSizeId;
  organizationTypeId: ReviewOrgDataOrganizationTypeId;
  partners: string[];
  registrationDate: ReviewOrgDataRegistrationDate;
  revenueAmount: ReviewOrgDataRevenueAmount;
  size: string;
  type: ReviewOrgDataType;
  updatedAt: string;
  website: ReviewOrgDataWebsite;
}

export type ReviewProAssignedProjectEndDate = string | null;

export type ReviewProAssignedProjectStartDate = string | null;

export interface ReviewProAssignedProject {
  endDate: ReviewProAssignedProjectEndDate;
  isTeam: boolean;
  name: string;
  projectId: number;
  startDate: ReviewProAssignedProjectStartDate;
}

export interface ReviewProCohortHistory {
  name: string;
  status: ReviewProCohortStatus;
}

export type ReviewProCohortStatus =
  (typeof ReviewProCohortStatus)[keyof typeof ReviewProCohortStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewProCohortStatus = {
  active: 'active',
  dropped: 'dropped',
  completed: 'completed',
} as const;

export type ReviewProDataApplicationDate = string | null;

export type ReviewProDataApplicationId = number | null;

export type ReviewProDataApplicationStatus = ProfessionalApplicationStatusEnum | null;

export type ReviewProDataAssignedProjects = ReviewProAssignedProject[] | null;

export type ReviewProDataBoardArea = string | null;

export type ReviewProDataCauses = string[] | null;

export type ReviewProDataCity = string | null;

export type ReviewProDataCohortHistory = ReviewProCohortHistory[] | null;

export type ReviewProDataCohortId = number | null;

export type ReviewProDataCohortName = string | null;

export type ReviewProDataCorporateClient = string | null;

export type ReviewProDataCountry = string | null;

export type ReviewProDataDisabledDate = string | null;

export type ReviewProDataEmployer = string | null;

export type ReviewProDataExperienceYears = number | null;

export type ReviewProDataInactiveDate = string | null;

export type ReviewProDataIndustries = string[] | null;

export type ReviewProDataJobTitle = string | null;

export type ReviewProDataLanguages = string[] | null;

export type ReviewProDataLinkedin = string | null;

export type ReviewProDataMotivationText = string | null;

export type ReviewProDataResume = string | null;

export type ReviewProDataSkills = string[] | null;

export type ReviewProDataSkillsExplanation = string | null;

export type ReviewProDataTeamId = number | null;

export type ReviewProDataTeamOptIn = boolean | null;

export type ReviewProDataWorkType = string | null;

export interface ReviewProData {
  applicationDate: ReviewProDataApplicationDate;
  applicationId: ReviewProDataApplicationId;
  applicationStatus: ReviewProDataApplicationStatus;
  assignedProjects: ReviewProDataAssignedProjects;
  boardArea: ReviewProDataBoardArea;
  causes: ReviewProDataCauses;
  city: ReviewProDataCity;
  cohortHistory: ReviewProDataCohortHistory;
  cohortId: ReviewProDataCohortId;
  cohortName: ReviewProDataCohortName;
  corporateClient: ReviewProDataCorporateClient;
  country: ReviewProDataCountry;
  disabledDate: ReviewProDataDisabledDate;
  email: string;
  employer: ReviewProDataEmployer;
  experienceYears: ReviewProDataExperienceYears;
  inactiveDate: ReviewProDataInactiveDate;
  industries: ReviewProDataIndustries;
  introsCount: number;
  jobTitle: ReviewProDataJobTitle;
  languages: ReviewProDataLanguages;
  linkedin: ReviewProDataLinkedin;
  motivationText: ReviewProDataMotivationText;
  name: string;
  resume: ReviewProDataResume;
  skills: ReviewProDataSkills;
  skillsExplanation: ReviewProDataSkillsExplanation;
  teamId: ReviewProDataTeamId;
  teamOptIn: ReviewProDataTeamOptIn;
  userId: number;
  workType: ReviewProDataWorkType;
}

export type ReviewProjectBenefits = string | null;

export type ReviewProjectBusinessType = string | null;

export type ReviewProjectDeliverables = string[] | null;

export type ReviewProjectEndDate = string | null;

export type ReviewProjectLearningOutcomes = string | null;

export type ReviewProjectStartDate = string | null;

export type ReviewProjectTimezone = string | null;

export interface ReviewProject {
  benefits: ReviewProjectBenefits;
  businessType: ReviewProjectBusinessType;
  cohorts: string[];
  deliverables: ReviewProjectDeliverables;
  description: string;
  endDate: ReviewProjectEndDate;
  expertises: string;
  goals: string;
  id: number;
  language: string;
  learningOutcomes: ReviewProjectLearningOutcomes;
  name: string;
  openToTeam: boolean;
  organizationId: number;
  organizationName: string;
  publishingStage: ProjectPublishingStage;
  publishingStageDate: string;
  roleType: ProjectRoleType;
  startDate: ReviewProjectStartDate;
  suggestedProject: boolean;
  timezone: ReviewProjectTimezone;
}

export type SAPApplicationParametersCohortId = number | null;

export type SAPApplicationParametersExperienceHopeOther = string | null;

export type SAPApplicationParametersLinkedin = string | null;

export type SAPApplicationParametersProfilePicture = string | null;

export type SAPApplicationParametersResume = string | null;

export interface SAPApplicationParameters {
  boardArea: BoardAreaEnum;
  city: string;
  cohortId: SAPApplicationParametersCohortId;
  country: number;
  experienceHope: ProfessionalExperienceHopeEnum[];
  experienceHopeOther: SAPApplicationParametersExperienceHopeOther;
  impactAreas: string[];
  industries: string[];
  jobTitle: string;
  languages: string[];
  linkedin: SAPApplicationParametersLinkedin;
  profilePicture: SAPApplicationParametersProfilePicture;
  referralMethod: string;
  resume: SAPApplicationParametersResume;
  skills: SkillsExperience[];
  skillsImpact: string;
  teamSelection: string;
  timezone: string;
  workType: WorkTypeEnum;
  yearsOfExperience: number;
}

export interface SAPSubmissionResponse {
  isEvergreen: boolean;
  status: ProfessionalApplicationStatusEnum;
}

export type SkillCategoriesEnum = (typeof SkillCategoriesEnum)[keyof typeof SkillCategoriesEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SkillCategoriesEnum = {
  'Marketing_&_Communications': 'Marketing & Communications',
  Financial_Management: 'Financial Management',
  Operations: 'Operations',
  Technology: 'Technology',
  'Industrial_Design_&_Engineering': 'Industrial Design & Engineering',
  'Product_Management_&_Design': 'Product Management & Design',
  Data: 'Data',
  People_Mgmt: 'People Mgmt',
  Business_Strategy: 'Business Strategy',
  'Medical_&_Science': 'Medical & Science',
  Sales: 'Sales',
} as const;

export type SearchProjectBusinessChallenge = string | null;

export type SearchProjectDeliverables = string | null;

export type SearchProjectDescription = string | null;

export type SearchProjectPlannedCohorts = string | null;

export type SearchProjectRepContinent = string | null;

export type SearchProjectRepCountry = string | null;

export type SearchProjectRepTimezone = string | null;

export type SearchProjectSkills = string | null;

export interface SearchProject {
  businessChallenge: SearchProjectBusinessChallenge;
  deliverables: SearchProjectDeliverables;
  description: SearchProjectDescription;
  id: number;
  name: string;
  organizationName: string;
  plannedCohorts: SearchProjectPlannedCohorts;
  publishingStage: string;
  repContinent: SearchProjectRepContinent;
  repCountry: SearchProjectRepCountry;
  repEmail: string;
  repFirstname: string;
  repLastname: string;
  repTimezone: SearchProjectRepTimezone;
  skills: SearchProjectSkills;
  status: string;
}

export interface SearchProjectsExportData {
  projects: SearchProject[];
}

export type SearchStatusEnum = (typeof SearchStatusEnum)[keyof typeof SearchStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchStatusEnum = {
  Active_Seeking: 'Active Seeking',
  Active_Team: 'Active Team',
  Not_Seeking: 'Not Seeking',
  Open_to_Intro: 'Open to Intro',
} as const;

export interface SearchUsersResponse {
  filteredCount: number;
  users: UserSearchCard[];
}

export interface SentIntroDetails {
  date: string;
  introId: number;
  message: string;
  orgId: number;
  orgName: string;
  proId: number;
  proName: string;
  projectId: number;
  projectName: string;
  role: string;
  timezone: string;
}

/**
 * A small wrapper around Job that includes the job's ID. This is the actual data type
that gets sent to the Azure Service Bus and passed to our API by the Azure Function App. The inner "job" field is what's then sent to the various handler functions when the job is processed.

Separating these is awkward but required as we don't know the job ID when the we create the Job object (like via EmailJob) in our application logic.
 */
export interface ServiceBusJob {
  id: number;
  job: Job;
}

export type SignUpWithPasswordParametersCorporateClientId = number | null;

export type SignUpWithPasswordParametersImpactPartnerId = number | null;

export type SignUpWithPasswordParametersIsRep = boolean | null;

export type SignUpWithPasswordParametersOrgInviteId = string | null;

export interface SignUpWithPasswordParameters {
  corporateClientId: SignUpWithPasswordParametersCorporateClientId;
  email: string;
  firstName: string;
  impactPartnerId: SignUpWithPasswordParametersImpactPartnerId;
  isRep: SignUpWithPasswordParametersIsRep;
  lastName: string;
  orgInviteId: SignUpWithPasswordParametersOrgInviteId;
  password: string;
}

export interface SimpleCorporateClient {
  id: number;
  name: string;
}

/**
 * A simplification of the roles in apps/api/src/models/Roles.py that reflects actual use, including
a case for unauthenticated users.
 */
export type SimplifiedUserRole = (typeof SimplifiedUserRole)[keyof typeof SimplifiedUserRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SimplifiedUserRole = {
  UNAUTHED: 'UNAUTHED',
  ADMIN: 'ADMIN',
  PROFESSIONAL: 'PROFESSIONAL',
  REPRESENTATIVE: 'REPRESENTATIVE',
} as const;

export interface SkillsExperience {
  experience: string;
  skill: string;
}

export type SocialMediaMapFacebook = string | null;

export type SocialMediaMapLinkedin = string | null;

export type SocialMediaMapSkype = string | null;

export type SocialMediaMapTwitter = string | null;

export interface SocialMediaMap {
  facebook: SocialMediaMapFacebook;
  linkedin: SocialMediaMapLinkedin;
  skype: SocialMediaMapSkype;
  twitter: SocialMediaMapTwitter;
}

export interface SuggestedProjectPayload {
  email_type?: 'SUGGEST_PROJECT';
  suggested_project_id: number;
}

export type SuggestionDateStatus = (typeof SuggestionDateStatus)[keyof typeof SuggestionDateStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuggestionDateStatus = {
  sent: 'sent',
  scheduled: 'scheduled',
} as const;

export interface SuggestionDate {
  date: string;
  status: SuggestionDateStatus;
}

export type SupportTypeInfoItemLearningOutcomes = string | null;

export type SupportTypeInfoItemProjectBackground = string | null;

export type SupportTypeInfoItemProjectTitle = string | null;

export interface SupportTypeInfoItem {
  deliverables: string[];
  learningOutcomes?: SupportTypeInfoItemLearningOutcomes;
  projectBackground?: SupportTypeInfoItemProjectBackground;
  projectTitle?: SupportTypeInfoItemProjectTitle;
  roleType: ProjectRoleType;
}

export type SurveyCoverageEnum = (typeof SurveyCoverageEnum)[keyof typeof SurveyCoverageEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyCoverageEnum = {
  self: 'self',
  stipend: 'stipend',
  employer: 'employer',
  shared: 'shared',
} as const;

export type SurveyInvestmentEnum = (typeof SurveyInvestmentEnum)[keyof typeof SurveyInvestmentEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyInvestmentEnum = {
  under_150: 'under_150',
  '150_500': '150_500',
  '500_900': '500_900',
  '900_2500': '900_2500',
  '2500_5000': '2500_5000',
  '5000_plus': '5000_plus',
  none_recent: 'none_recent',
} as const;

export type SurveyOutcomeEnum = (typeof SurveyOutcomeEnum)[keyof typeof SurveyOutcomeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyOutcomeEnum = {
  community: 'community',
  practice: 'practice',
  credential: 'credential',
} as const;

export type SurveyTriggerEnum = (typeof SurveyTriggerEnum)[keyof typeof SurveyTriggerEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyTriggerEnum = {
  pivot: 'pivot',
  grow_in_role: 'grow_in_role',
  between_roles: 'between_roles',
  give_back: 'give_back',
  other: 'other',
} as const;

export interface TeamHubProgressResponse {
  action: ProgressStepStatusEnum;
  planning: ProgressStepStatusEnum;
  reflect: ProgressStepStatusEnum;
}

export interface TeamMatchCohort {
  id: number;
  name: string;
}

export interface TeamMatchConfirmationPayload {
  email_type?: 'PROJECT_MATCHED_TEAMS';
  team_assignment_id: number;
}

export interface TeamMatchCorporateClient {
  id: number;
  name: string;
}

export type TeamMatchDetailsPlanningGuideUrl = string | null;

export type TeamMatchDetailsProjectPlanId = number | null;

export interface TeamMatchDetails {
  cohort: TeamMatchCohort;
  corporateClient: TeamMatchCorporateClient;
  myProjectsStatus: CardStatusEnum;
  myProjectsStatusDate: string;
  organization: IntroductionOrganization;
  planningGuideUrl: TeamMatchDetailsPlanningGuideUrl;
  project: IntroductionProject;
  projectPlanId: TeamMatchDetailsProjectPlanId;
  representative: IntroductionRepresentative;
  team: TeamMatchTeam;
  teamDiscoveryId: number;
}

export type TeamMatchDetailsResponseActionUpdates = IntroActionUpdate[] | null;

export type TeamMatchDetailsResponsePlanUpdates = IntroPlanUpdate[] | null;

export type TeamMatchDetailsResponseProjectPlan = AdminProjectPlan | null;

export interface TeamMatchDetailsResponse {
  actionUpdates: TeamMatchDetailsResponseActionUpdates;
  planUpdates: TeamMatchDetailsResponsePlanUpdates;
  projectPlan: TeamMatchDetailsResponseProjectPlan;
  teamMatchDetails: TeamMatchDetails;
}

export interface TeamMatchTeam {
  id: number;
  members: IntroductionProfessional[];
}

export interface TeamPostMatchSurveyFourteenDaysProPayload {
  email_type?: 'TEAM_POST_MATCH_SURVEY_FOURTEEN_DAYS_PRO';
  pro_user_id: number;
  team_assignment_id: number;
}

export interface TeamPostMatchSurveyFourteenDaysRepPayload {
  email_type?: 'TEAM_POST_MATCH_SURVEY_FOURTEEN_DAYS_REP';
  team_assignment_id: number;
}

export interface TeamPostMatchSurveyOneDayProPayload {
  email_type?: 'TEAM_POST_MATCH_SURVEY_ONE_DAY_PRO';
  pro_user_id: number;
  team_assignment_id: number;
}

export interface TeamPostMatchSurveyOneDayRepPayload {
  email_type?: 'TEAM_POST_MATCH_SURVEY_ONE_DAY_REP';
  team_assignment_id: number;
}

export interface TeamProjectActionIncompleteMinusSevenDaysPayload {
  email_type?: 'TEAM_ACTION_INCOMPLETE_MINUS_SEVEN_DAYS';
  team_assignment_id: number;
  user_id: number;
}

export interface TeamProjectActionIncompletePayload {
  email_type?: 'TEAM_ACTION_INCOMPLETE';
  team_assignment_id: number;
  user_id: number;
}

export interface TeamProjectActionIncompletePlusSevenDaysPayload {
  email_type?: 'TEAM_ACTION_INCOMPLETE_PLUS_SEVEN_DAYS';
  team_assignment_id: number;
  user_id: number;
}

export type TeamProjectHubResponsePlanningGuideUrl = string | null;

export type TeamProjectHubResponseProjectPlanId = number | null;

export type TeamProjectHubResponseStoryUrl = string | null;

export type TeamProjectHubResponseSurveyUrl = string | null;

export interface TeamProjectHubResponse {
  action: HubActionData;
  displayPlanUi: boolean;
  organization: HubOrganization;
  planningGuideUrl: TeamProjectHubResponsePlanningGuideUrl;
  professionals: HubContactCard[];
  progress: TeamHubProgressResponse;
  project: HubProject;
  projectPlanId: TeamProjectHubResponseProjectPlanId;
  representative: HubContactCard;
  status: HubStatusEnum;
  storyUrl: TeamProjectHubResponseStoryUrl;
  surveyUrl: TeamProjectHubResponseSurveyUrl;
  userType: SimplifiedUserRole;
}

export interface TeamProjectPlanIncompleteFifteenDaysPayload {
  email_type?: 'TEAM_PLAN_INCOMPLETE_REMINDER_FIFTEEN_DAYS';
  team_assignment_id: number;
  user_id: number;
}

export interface TeamProjectPlanIncompleteFifteenDaysPayloadV2 {
  email_type?: 'TEAM_PLAN_INCOMPLETE_REMINDER_FIFTEEN_DAYS_V2';
  team_assignment_id: number;
  user_id: number;
}

export interface TeamProjectPlanIncompleteTenDaysPayload {
  email_type?: 'TEAM_PLAN_INCOMPLETE_REMINDER_TEN_DAYS';
  team_assignment_id: number;
  user_id: number;
}

export interface TeamProjectPlanIncompleteTenDaysPayloadV2 {
  email_type?: 'TEAM_PLAN_INCOMPLETE_REMINDER_TEN_DAYS_V2';
  team_assignment_id: number;
  user_id: number;
}

export type TeamSkillProficiencyProficiencyCounts = { [key: string]: number };

export interface TeamSkillProficiency {
  proficiencyCounts: TeamSkillProficiencyProficiencyCounts;
  skill: string;
  total: number;
}

export type TheatreEnum = (typeof TheatreEnum)[keyof typeof TheatreEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TheatreEnum = {
  APCJ: 'APCJ',
  EMEA: 'EMEA',
  LATAM: 'LATAM',
  INDIA: 'INDIA',
  NORTH_AMERICA: 'NORTH_AMERICA',
} as const;

export interface UnassignProjectRequest {
  projectId: number;
  teamId: number;
}

export interface UpdateCohort {
  id: number;
  name: string;
}

export interface UpdateCohortClient {
  cohorts: UpdateCohort[];
  id: number;
  name: string;
}

export type UpdateCohortRequestCohortId = number | null;

export interface UpdateCohortRequest {
  clientId: number;
  cohortId: UpdateCohortRequestCohortId;
  userId: number;
}

export interface UpdateDeliverable {
  context: string;
  deliverable: string;
}

export interface UpdateDeliverablesRequest {
  deliverables: UpdateDeliverable[];
}

export interface UpdateEmailRequest {
  newEmail: string;
}

export interface UpdateEmailVerificationRequest {
  userId: number;
  verified: boolean;
}

export type UpdateIntroductionStatusResponseAssignmentDiscoveryId = number | null;

export interface UpdateIntroductionStatusResponse {
  assignmentDiscoveryId: UpdateIntroductionStatusResponseAssignmentDiscoveryId;
  status: IntroductionStatusEnum;
}

export interface UpdateMeetingsResponse {
  updated_meetings: number[];
}

export type UpdateMyProjectsStatusRequestDiscoveryProDecision = DiscoveryDecision | null;

export type UpdateMyProjectsStatusRequestDiscoveryProReason = AssignmentDeclinedReason | null;

export type UpdateMyProjectsStatusRequestDiscoveryRepDecision = DiscoveryDecision | null;

export type UpdateMyProjectsStatusRequestDiscoveryRepReason = AssignmentDeclinedReason | null;

export type UpdateMyProjectsStatusRequestIntroductionReasonId = number | null;

export type UpdateMyProjectsStatusRequestProjectEndDate = string | null;

export type UpdateMyProjectsStatusRequestProjectName = string | null;

export type UpdateMyProjectsStatusRequestProjectStartDate = string | null;

export type UpdateMyProjectsStatusRequestSendEmail = boolean | null;

export interface UpdateMyProjectsStatusRequest {
  discoveryProDecision: UpdateMyProjectsStatusRequestDiscoveryProDecision;
  discoveryProReason: UpdateMyProjectsStatusRequestDiscoveryProReason;
  discoveryRepDecision: UpdateMyProjectsStatusRequestDiscoveryRepDecision;
  discoveryRepReason: UpdateMyProjectsStatusRequestDiscoveryRepReason;
  introductionId: number;
  introductionOutcome: IntroductionOutcomeEnum;
  introductionReasonId: UpdateMyProjectsStatusRequestIntroductionReasonId;
  projectEndDate: UpdateMyProjectsStatusRequestProjectEndDate;
  projectName: UpdateMyProjectsStatusRequestProjectName;
  projectStartDate: UpdateMyProjectsStatusRequestProjectStartDate;
  sendEmail: UpdateMyProjectsStatusRequestSendEmail;
}

export type UpdateNotesRequestNotes = string | null;

export interface UpdateNotesRequest {
  meetingRegistrantId: number;
  notes: UpdateNotesRequestNotes;
}

export interface UpdateOrgBriefRequest {
  constraints: string;
  impact: string;
  objective: string;
  obstacle: string;
  primaryOutcome: string;
  questions: string;
  stepsTaken: string;
}

export type UpdateOrganizationRequestBusinessModel = string | null;

export type UpdateOrganizationRequestBusinessModelDescription = string | null;

export type UpdateOrganizationRequestBusinessProblem = string | null;

export type UpdateOrganizationRequestBusinessSolution = string | null;

export type UpdateOrganizationRequestCauses = string[] | null;

export type UpdateOrganizationRequestChallengeOne = BusinessChallengesEnum | null;

export type UpdateOrganizationRequestChallengeOneDescription = string | null;

export type UpdateOrganizationRequestChallengeThree = BusinessChallengesEnum | null;

export type UpdateOrganizationRequestChallengeThreeDescription = string | null;

export type UpdateOrganizationRequestChallengeTwo = BusinessChallengesEnum | null;

export type UpdateOrganizationRequestChallengeTwoDescription = string | null;

export type UpdateOrganizationRequestCorporateClient = string | null;

export type UpdateOrganizationRequestCountries = string[] | null;

export type UpdateOrganizationRequestDescription = string | null;

export type UpdateOrganizationRequestGeneratingRevenue = boolean | null;

export type UpdateOrganizationRequestImpactPartners = string[] | null;

export type UpdateOrganizationRequestImpactStory = string | null;

export type UpdateOrganizationRequestIndustries = string[] | null;

export type UpdateOrganizationRequestLinkedin = string | null;

export type UpdateOrganizationRequestLogoUrl = string | null;

export type UpdateOrganizationRequestName = string | null;

export type UpdateOrganizationRequestOrganizationSize = string | null;

export type UpdateOrganizationRequestOrganizationType = string | null;

export type UpdateOrganizationRequestRegistrationCountry = string | null;

export type UpdateOrganizationRequestRegistrationYear = number | null;

export type UpdateOrganizationRequestWebsite = string | null;

export interface UpdateOrganizationRequest {
  businessModel: UpdateOrganizationRequestBusinessModel;
  businessModelDescription: UpdateOrganizationRequestBusinessModelDescription;
  businessProblem: UpdateOrganizationRequestBusinessProblem;
  businessSolution: UpdateOrganizationRequestBusinessSolution;
  causes: UpdateOrganizationRequestCauses;
  challengeOne: UpdateOrganizationRequestChallengeOne;
  challengeOneDescription: UpdateOrganizationRequestChallengeOneDescription;
  challengeThree: UpdateOrganizationRequestChallengeThree;
  challengeThreeDescription: UpdateOrganizationRequestChallengeThreeDescription;
  challengeTwo: UpdateOrganizationRequestChallengeTwo;
  challengeTwoDescription: UpdateOrganizationRequestChallengeTwoDescription;
  corporateClient: UpdateOrganizationRequestCorporateClient;
  countries: UpdateOrganizationRequestCountries;
  description: UpdateOrganizationRequestDescription;
  generatingRevenue: UpdateOrganizationRequestGeneratingRevenue;
  impactPartners: UpdateOrganizationRequestImpactPartners;
  impactStory: UpdateOrganizationRequestImpactStory;
  industries: UpdateOrganizationRequestIndustries;
  linkedin: UpdateOrganizationRequestLinkedin;
  logoUrl: UpdateOrganizationRequestLogoUrl;
  name: UpdateOrganizationRequestName;
  organizationId: number;
  organizationSize: UpdateOrganizationRequestOrganizationSize;
  organizationType: UpdateOrganizationRequestOrganizationType;
  registrationCountry: UpdateOrganizationRequestRegistrationCountry;
  registrationYear: UpdateOrganizationRequestRegistrationYear;
  website: UpdateOrganizationRequestWebsite;
}

export interface UpdatePasswordParameters {
  newPassword: string;
  verificationToken: string;
}

export interface UpdateProBriefRequest {
  questions: string;
}

export type UpdateProfileRequestCity = string | null;

export type UpdateProfileRequestCountry = number | null;

export type UpdateProfileRequestIndustries = string[] | null;

export type UpdateProfileRequestJobTitle = string | null;

export type UpdateProfileRequestLanguages = string[] | null;

export type UpdateProfileRequestLinkedin = string | null;

export type UpdateProfileRequestProfilePicture = string | null;

export type UpdateProfileRequestResume = string | null;

export type UpdateProfileRequestSkills = SkillsExperience[] | null;

export type UpdateProfileRequestTimezone = string | null;

export type UpdateProfileRequestYearsOfExperience = number | null;

export interface UpdateProfileRequest {
  city: UpdateProfileRequestCity;
  country: UpdateProfileRequestCountry;
  industries: UpdateProfileRequestIndustries;
  jobTitle: UpdateProfileRequestJobTitle;
  languages: UpdateProfileRequestLanguages;
  linkedin: UpdateProfileRequestLinkedin;
  profilePicture: UpdateProfileRequestProfilePicture;
  resume: UpdateProfileRequestResume;
  skills: UpdateProfileRequestSkills;
  timezone: UpdateProfileRequestTimezone;
  yearsOfExperience: UpdateProfileRequestYearsOfExperience;
}

export interface UpdateProjectDatesModel {
  end_date: string;
  is_team: boolean;
  project_id: number;
  start_date: string;
}

export type UpdateProjectPlanRequestAvailabilityNotes = string | null;

export type UpdateProjectPlanRequestCommunicationNotes = string | null;

export type UpdateProjectPlanRequestNextSteps = string | null;

export interface UpdateProjectPlanRequest {
  availabilityNotes: UpdateProjectPlanRequestAvailabilityNotes;
  communicationNotes: UpdateProjectPlanRequestCommunicationNotes;
  nextSteps: UpdateProjectPlanRequestNextSteps;
}

export type UpdatePublishStageRequestRevisionNotes = string | null;

export interface UpdatePublishStageRequest {
  projectId: number;
  publishStage: ProjectPublishingStage;
  revisionNotes: UpdatePublishStageRequestRevisionNotes;
  sendEmail: boolean;
}

export interface UpdateSkillAlignment {
  skillsAlignment: string;
  userId: number;
}

export interface UpdateSkillAlignmentsRequest {
  skillAlignments: UpdateSkillAlignment[];
}

export type UpdateStatusBatchRequestSendEmail = boolean | null;

export interface UpdateStatusBatchRequest {
  sendEmail: UpdateStatusBatchRequestSendEmail;
  status: ProfessionalApplicationStatusEnum;
  userIds: number[];
}

export interface UpdateTask {
  task: string;
  userId: number;
}

export interface UpdateTasksRequest {
  tasks: UpdateTask[];
}

export type UpdateTeamAssignmentRequestOrganizationDecision =
  (typeof UpdateTeamAssignmentRequestOrganizationDecision)[keyof typeof UpdateTeamAssignmentRequestOrganizationDecision];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTeamAssignmentRequestOrganizationDecision = {
  pending: 'pending',
  accepted: 'accepted',
  declined: 'declined',
} as const;

export type UpdateTeamAssignmentRequestScheduledSendDate = string | null;

export interface UpdateTeamAssignmentRequest {
  organizationDecision: UpdateTeamAssignmentRequestOrganizationDecision;
  projectId: number;
  scheduledSendDate: UpdateTeamAssignmentRequestScheduledSendDate;
  sendEmail: boolean;
  teamId: number;
}

export interface UpdateTeamMembersRequest {
  memberIds: number[];
  teamId: number;
}

export interface UploadError {
  error: string;
}

export interface UploadResponse {
  url: string;
}

export interface UserActionUpdate {
  createdAt: string;
  id: number;
  outcome: ActionUpdateOutcomeEnum;
}

export type UserRejoinDataResponseLastCohortStatus = 'complete' | 'dropped' | null;

export interface UserRejoinDataResponse {
  cohorts: CohortResponse[];
  lastCohortStatus: UserRejoinDataResponseLastCohortStatus;
}

export type UserSearchCardCountry = string | null;

export type UserSearchCardCountryCode = string | null;

export type UserSearchCardEmployer = string | null;

export type UserSearchCardFirstName = string | null;

export type UserSearchCardHeadline = string | null;

export type UserSearchCardImage = string | null;

export type UserSearchCardLastName = string | null;

export type UserSearchCardPositionTitle = string | null;

export type UserSearchCardYearsExperience = number | null;

export interface UserSearchCard {
  country: UserSearchCardCountry;
  countryCode: UserSearchCardCountryCode;
  employer: UserSearchCardEmployer;
  firstName: UserSearchCardFirstName;
  headline: UserSearchCardHeadline;
  id: number;
  image: UserSearchCardImage;
  languages: string[];
  lastName: UserSearchCardLastName;
  positionTitle: UserSearchCardPositionTitle;
  skills: string[];
  yearsExperience: UserSearchCardYearsExperience;
}

export interface UserSignupImpactPartner {
  id: number;
  name: string;
}

export type UserTeamAssignmentStatusEnum =
  (typeof UserTeamAssignmentStatusEnum)[keyof typeof UserTeamAssignmentStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserTeamAssignmentStatusEnum = {
  proposed: 'proposed',
  approved: 'approved',
  rejected: 'rejected',
  canceled: 'canceled',
  withdrawn: 'withdrawn',
  complete: 'complete',
} as const;

export type ValidationErrorCtx = { [key: string]: unknown };

export type ValidationErrorLocItem = string | number;

export interface ValidationError {
  ctx?: ValidationErrorCtx;
  input?: unknown;
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
}

export type WorkTypeEnum = (typeof WorkTypeEnum)[keyof typeof WorkTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkTypeEnum = {
  'part-time': 'part-time',
  'full-time': 'full-time',
  unemployed: 'unemployed',
} as const;

export interface SrcRoutersAdminCohortsSimpleCohort {
  corporateClientName: string;
  id: number;
  name: string;
}

export type SrcRoutersAdminOrganizationsUpdateApplicationStatusRequestNotes = string | null;

export type SrcRoutersAdminOrganizationsUpdateApplicationStatusRequestSendEmail = boolean | null;

export interface SrcRoutersAdminOrganizationsUpdateApplicationStatusRequest {
  applicationId: number;
  notes: SrcRoutersAdminOrganizationsUpdateApplicationStatusRequestNotes;
  organizationId: number;
  sendEmail: SrcRoutersAdminOrganizationsUpdateApplicationStatusRequestSendEmail;
  status: OrganizationApplicationStatusEnum;
}

export type SrcRoutersAdminProfessionalsUpdateApplicationStatusRequestSendEmail = boolean | null;

export interface SrcRoutersAdminProfessionalsUpdateApplicationStatusRequest {
  applicationId: number;
  sendEmail: SrcRoutersAdminProfessionalsUpdateApplicationStatusRequestSendEmail;
  status: ProfessionalApplicationStatusEnum;
}

export interface SrcRoutersCohortsSimpleCohort {
  id: number;
  name: string;
}

export type GetAdminCohortsParams = {
  id?: number | null;
  name?: string | null;
  client_name?: string | null;
  template?: string | null;
  time_commitment?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetEventsAdminParams = {
  page: number;
  limit: number;
  sort?: string | null;
};

export type GetFundingOpportunitiesAdminParams = {
  page: number;
  limit: number;
  sort?: string | null;
};

export type GetIntroductionsParams = {
  introduction_id?: number | null;
  organization_name?: string | null;
  project_name?: string | null;
  my_projects_status?: string | null;
  introduction_initiation_type?: string | null;
  professional_name?: string | null;
  cohort?: string | null;
  representative_name?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type BatchImportIntroductionsParams = {
  send_email?: boolean | null;
  scheduled_send_date?: string | null;
};

export type GetIntroductionsExportDataParams = {
  introduction_id?: number | null;
  organization_name?: string | null;
  project_name?: string | null;
  my_projects_status?: string | null;
  introduction_initiation_type?: string | null;
  professional_name?: string | null;
  cohort?: string | null;
  representative_name?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetJobPostingsAdminParams = {
  page: number;
  limit: number;
  sort?: string | null;
};

export type GetAdminTeamsMatchingDataParams = {
  team_discovery_id?: number | null;
  project_id?: number | null;
  professional_id?: number | null;
  representative_id?: number | null;
  team_id?: number | null;
  organization_id?: number | null;
  project?: string | null;
  organization?: string | null;
  corporate_client?: string | null;
  cohort?: string | null;
  my_projects_status?: string | null;
  team_members?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetAdminTeamsMatchingExportDataParams = {
  team_discovery_id?: number | null;
  project_id?: number | null;
  professional_id?: number | null;
  representative_id?: number | null;
  team_id?: number | null;
  organization_id?: number | null;
  project?: string | null;
  organization?: string | null;
  corporate_client?: string | null;
  cohort?: string | null;
  my_projects_status?: string | null;
  team_members?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetMeetingsParams = {
  title?: string | null;
  zoom_host?: string | null;
  start_time?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetCommunityMeetingDetailParams = {
  meeting_id: number;
  page: number;
  limit: number;
  filter?: string | null;
  sort?: string | null;
};

export type GetEirMeetingDetailParams = {
  meeting_id: number;
};

export type RefreshMeetingParams = {
  zoom_id: string;
};

export type GetRegistrationsDownloadDataParams = {
  meeting_id: number;
  filter?: string | null;
};

export type UpdateAttendanceParams = {
  meeting_registrant_id: number;
  attended: boolean;
};

export type GetAdminMicrostoriesParams = {
  name?: string | null;
  organization?: string | null;
  story?: string | null;
  user_type?: string | null;
  corporate_client?: string | null;
  story_date?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetOrganizationsParams = {
  page: number;
  limit: number;
  sort?: string | null;
  filter?: string | null;
};

export type GetOrganizationMatchDataParams = {
  organization_id: number;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetOrganizationTeamMatchDataParams = {
  organization_id: number;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetOrganizationProjectsParams = {
  organization__id: number;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetAdminPartnersParams = {
  id?: number | null;
  name?: string | null;
  active?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetPartnerIdByUrlParamParams = {
  url_param: string;
};

export type GetAdminProfessionalsParams = {
  id?: number | null;
  name?: string | null;
  email?: string | null;
  skills?: string | null;
  client_name?: string | null;
  cohort_name?: string | null;
  apply_completed?: string | null;
  application_status?: string | null;
  created_at?: string | null;
  sort?: string | null;
  page?: number | null;
  limit?: number | null;
};

export type GetCohortsByClientsParams = {
  current_only?: boolean | null;
};

export type GetUserExportDataParams = {
  id?: number | null;
  name?: string | null;
  email?: string | null;
  skills?: string | null;
  client_name?: string | null;
  cohort_name?: string | null;
  apply_completed?: string | null;
  application_status?: string | null;
  created_at?: string | null;
  sort?: string | null;
  page?: number | null;
  limit?: number | null;
};

export type GetProsMatchingDataParams = {
  user_id: number;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetProsTeamMatchingDataParams = {
  user_id: number;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetProjectsParams = {
  id?: number | null;
  name?: string | null;
  organization_name?: string | null;
  representative_name?: string | null;
  open_to_team?: string | null;
  stage?: string | null;
  skills?: string | null;
  cohorts?: string | null;
  publishing_stage?: string | null;
  created_at?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
  start_date?: string | null;
  end_date?: string | null;
};

export type GetProjectMatchDataParams = {
  project_id: number;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type GetProjectTeamMatchDataParams = {
  project_id: number;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type CreateProjectRecommendation200 =
  ProjectRecommendationSuccessResponse | ProjectRecommendationErrorResponse;

export type GetRepresentativesParams = {
  id?: number | null;
  name?: string | null;
  email?: string | null;
  organization_name?: string | null;
  organization_id?: number | null;
  created_at?: string | null;
  updated_at?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
};

export type SearchOrganizationsByNameParams = {
  query?: string;
};

export type GetProResultExportDataParams = {
  corporate_client?: string | null;
  cohort?: string | null;
  application_status?: string | null;
  timezone?: string | null;
  match_status?: string | null;
  max_introductions?: string | null;
  search_status?: string | null;
  requested_cohort_notifications?: string | null;
  page?: number | null;
  limit?: number | null;
};

export type GetProfessionalUsersParams = {
  corporate_client?: string | null;
  cohort?: string | null;
  application_status?: string | null;
  timezone?: string | null;
  match_status?: string | null;
  max_introductions?: string | null;
  search_status?: string | null;
  requested_cohort_notifications?: string | null;
  page?: number | null;
  limit?: number | null;
};

export type AdminSearchProjectsParams = {
  assigned?: boolean | null;
  publishing_stage?: string | null;
  corporate_client?: string | null;
  planned_cohort?: string | null;
  business_challenges?: string | null;
  page?: number | null;
  limit?: number | null;
};

export type GetAdminSearchProjectExportParams = {
  assigned?: boolean | null;
  publishing_stage?: string | null;
  corporate_client?: string | null;
  planned_cohort?: string | null;
  business_challenges?: string | null;
  page?: number | null;
  limit?: number | null;
};

export type GetRepResultExportDataParams = {
  timezone?: string | null;
  application_status?: string | null;
  corporate_client?: string | null;
  impact_partner?: string | null;
  industries?: string | null;
  continents?: string | null;
  cohort_matches?: string | null;
  has_published?: string | null;
  has_published_unmatched?: boolean | null;
  match_status?: string | null;
  business_challenges?: string | null;
  page?: number | null;
  limit?: number | null;
};

export type GetRepUsersParams = {
  timezone?: string | null;
  application_status?: string | null;
  corporate_client?: string | null;
  impact_partner?: string | null;
  industries?: string | null;
  continents?: string | null;
  cohort_matches?: string | null;
  has_published?: string | null;
  has_published_unmatched?: boolean | null;
  match_status?: string | null;
  business_challenges?: string | null;
  page?: number | null;
  limit?: number | null;
};

export type SearchUsersByNameParams = {
  query?: string;
};

export type GetTeamsParams = {
  cohort_id: number;
  page?: number | null;
  limit?: number | null;
};

export type GetTeamsCountsParams = {
  cohort_id: number;
};

export type DeleteTeamParams = {
  team_id: number;
};

export type GetTeamDetailsParams = {
  team_id: number;
};

export type GetFreeAgentsParams = {
  cohort_id: number;
  page?: number | null;
  limit?: number | null;
};

export type GetTeamIdsParams = {
  cohort_id: number;
};

export type GetTeamMembersParams = {
  team_id: number;
};

export type GetNewMemberParams = {
  user_id: number;
};

export type OrganizationExistsParams = {
  organization_name: string;
};

export type UploadLogo200 = UploadResponse | UploadError;

export type UploadProfilePicture200 = UploadResponse | UploadError;

export type UploadResume200 = UploadResponse | UploadError;

export type CloseUserPendingConnectionsParams = {
  notify?: boolean;
};

export type GetCurrentUserCurrentCohort200 = CohortBaseDetail | null;

export type GetCommunityAnnouncementsParams = {
  page: number;
  limit: number;
  sort?: string | null;
  type?: AnnouncementTypeEnum | null;
};

export type GetCommunityWinsParams = {
  page: number;
  limit: number;
  sort?: string | null;
};

export type GetClientCohortsParams = {
  corporate_client_id?: number | null;
};

export type UpdateRecentUpdate200 = RecentUpdateData | null;

export type UpdateSearchStatusBody =
  EarliestDateAvailableResponse | NotSeekingNoDateResponse | NotSeekingPostponingResponse;

export type UpdateSearchStatus200 = { [key: string]: SearchStatusEnum };

export type DeleteProjectParams = {
  project_id: number;
};

export type UpdateDiscoveryCallBody =
  | DiscoveryCallProAcceptedRequest
  | DiscoveryCallRepAcceptedRequest
  | DiscoveryCallRejectedRequest
  | DiscoveryCallScheduledUpdateRequest
  | DiscoveryCallUnresponsiveUpdateRequest
  | DiscoveryCallOtherUpdateRequest
  | DiscoveryCallNeedHelpUpdateRequest
  | DiscoveryCallStillDecidingUpdateRequest
  | DiscoveryCallMatchedElsewhereUpdateRequest;

export type UpdateDiscoveryCall200 = { [key: string]: boolean };

export type GetPastMovingworldsEventsParams = {
  page: number;
  limit: number;
  sort?: string | null;
};

export type GetUpcomingEventsParams = {
  page: number;
  limit: number;
  sort?: string | null;
};

export type GetFundingOpportunitiesParams = {
  page: number;
  limit: number;
  sort?: string | null;
};

export type SendIntroduction200 = { [key: string]: number };

export type UpdateStatusBody = AcceptIntroductionRequest | DeclineIntroductionRequest;

export type GetJobPostingsParams = {
  page: number;
  limit: number;
  sort?: string | null;
};

export type LoginGoogleParams = {
  org_invite_id?: string | null;
  is_rep?: boolean | null;
  impact_partner_id?: number | null;
  corporate_client_id?: number | null;
};

export type LoginLinkedinParams = {
  org_invite_id?: string | null;
  is_rep?: boolean | null;
  impact_partner_id?: number | null;
  corporate_client_id?: number | null;
};

export type VerifyEmailParams = {
  token: string;
};

export type GetProjectHubDataParams = {
  assignment_discovery_id: number;
};

export type GetTeamProjectHubDataParams = {
  project_id: number;
};

export type SendProjectSuggestEmailParams = {
  suggested_project_id: number;
  scheduled_email_date?: string | null;
};

export type GetEditableProjectParams = {
  project_id: number;
};

export type EditProjectParams = {
  project_id: number;
};

export type SearchOrganizationsParams = {
  sort?: string | null;
  page?: number | null;
  limit?: number | null;
  causes?: string | null;
  countries?: string | null;
  industries?: string | null;
};

export type SearchProjectsParams = {
  skills?: string | null;
  roles?: string | null;
  page?: number | null;
  limit?: number | null;
  sort?: string | null;
  languages?: string | null;
  causes?: string | null;
};

export type SearchProUsersParams = {
  page?: number | null;
  limit?: number | null;
  languages?: string | null;
  skills?: string | null;
};

export type HandleTeamAssignmentDiscoveryDecisionParams = {
  decision: DiscoveryDecision;
};

export type UnsaveProjectParams = {
  project_id: number;
};

export type GetCurrentUser200 = ProfessionalUser | OrgRepUser | AdminUser | CorporateAdmin;

export type GetUserSignupPartner200 = UserSignupImpactPartner | null;
